var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessPlanPana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.06,399.75c4.18-2.15,9.11-2.43,13.75-1.67,2.49.42,5.09,1.16,6.79,3s2,5.17.07,6.78a6.48,6.48,0,0,1-4.28,1.08c-3.64,0-7.67-.68-10.57,1.51-1.66,1.25-2.76,3.32-4.74,3.93a4.69,4.69,0,0,1-5.16-2.29,8,8,0,0,1-.58-5.9A9,9,0,0,1,107.06,399.75Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.48,381.26c2.55,3.65,7.52,2.44,9.83.21s3.28-5.46,4.16-8.54c2-7,4.07-14.43,2.57-21.6a12.06,12.06,0,0,0-2.76-5.87,6.27,6.27,0,0,0-5.94-2c-2.51.66-4.07,3.12-5.19,5.45A51.58,51.58,0,0,0,95.06,371c0,3.56.41,7.29,2.42,10.23",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,386.5c2.78-3.3,3.31-8.11,2.07-12.23a23.59,23.59,0,0,0-7.24-10.51,39.2,39.2,0,0,0-13-7.66,13.77,13.77,0,0,0-5.83-1,6.14,6.14,0,0,0-4.9,3c-1.36,2.61,0,5.77,1.36,8.34a99.72,99.72,0,0,0,8.52,13c2.56,3.29,5.48,6.54,9.38,8s7.93,1.31,10-1.39",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3,436.36a7.46,7.46,0,0,0,.23-1.66c.12-1.21.27-2.73.44-4.53s.49-4.18,1-6.65a51.88,51.88,0,0,1,2.42-7.84,29,29,0,0,1,4-7.09,15,15,0,0,1,5.07-4.21,14,14,0,0,1,4.26-1.33,7.72,7.72,0,0,0,1.65-.24,8.06,8.06,0,0,0-1.68,0,13.2,13.2,0,0,0-4.45,1.16,15,15,0,0,0-5.34,4.25,28.29,28.29,0,0,0-4.15,7.24,47.18,47.18,0,0,0-2.39,8,54.6,54.6,0,0,0-.89,6.72c-.14,1.93-.2,3.48-.22,4.56A8.19,8.19,0,0,0,97.3,436.36Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,432.87a2.85,2.85,0,0,0,0-.77c0-.58,0-1.31,0-2.2,0-1.91,0-4.68.1-8.09.17-6.83.76-14.19,1.89-24.55,1.08-9.75,2.52-21.09,4-28.46.33-1.68.65-3.19,1-4.51s.55-2.47.8-3.39.37-1.58.51-2.14a2.73,2.73,0,0,0,.13-.76,3.35,3.35,0,0,0-.26.72c-.17.55-.38,1.25-.64,2.11s-.58,2.05-.91,3.37-.71,2.82-1.07,4.5A252.67,252.67,0,0,0,99,395.11c-1.13,10.38-1.65,19.84-1.69,26.69,0,3.42,0,6.19.12,8.11,0,.89.1,1.62.13,2.2A3.83,3.83,0,0,0,97.61,432.87Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.66,414.63a14,14,0,0,0,0-2.3,61,61,0,0,0-.7-6.23,81.79,81.79,0,0,0-2-9.08,74.32,74.32,0,0,0-3.79-10.75A57.06,57.06,0,0,0,80,368.91a27,27,0,0,0-2.62-2.44c-.4-.34-.76-.68-1.12-1l-1-.7a13.53,13.53,0,0,0-1.94-1.24,68.34,68.34,0,0,1,6.35,5.66,60.46,60.46,0,0,1,10.88,17.3,87,87,0,0,1,3.82,10.65c1,3.34,1.65,6.41,2.15,9s.75,4.71.92,6.17A15.09,15.09,0,0,0,97.66,414.63Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.03 446.81 81.86 471.85 114.03 471.85 115.85 446.81 80.03 446.81",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.92,
    y: 436.94,
    width: 42.77,
    height: 9.87,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.92 470.89 76.92 473.63 78.93 473.63 118.98 473.63 118.98 470.89 76.92 470.89",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.9 478.44 78.93 473.63 117.45 473.63 115.16 478.44 80.9 478.44",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.26,455l-.15.23-.48.64-1.88,2.4-.08.1-.08-.11L108,451.88h.27l-4.53,6.42-.15.2-.15-.19L98,451.92h.31l-.3.38-4.8,6-.16.2-.15-.21-4.54-6.41h.27c-2.24,2.55-4.13,4.71-5.59,6.36l-.1.12-.07-.13c-.74-1.24-1.33-2.22-1.75-2.94l-.45-.78a1.9,1.9,0,0,1-.14-.28s.08.08.19.25l.5.75,1.83,2.89-.17,0,5.49-6.44.14-.16.13.17,4.57,6.39H93l4.79-6c.1-.13.2-.26.3-.37l.15-.2.16.19,5.36,6.41h-.3L108,451.7l.14-.19.13.19c1.81,2.59,3.35,4.79,4.51,6.43h-.17l2-2.34.52-.6A1,1,0,0,1,115.26,455Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,446.64c0,.11-8.06.2-18,.2s-18-.09-18-.2,8.06-.2,18-.2S116.3,446.53,116.3,446.64Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,473.89c0,.12-8.76.2-19.57.2s-19.56-.08-19.56-.2,8.76-.2,19.56-.2S117.93,473.78,117.93,473.89Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.91,
    y: 99.21,
    width: 213.13,
    height: 80.77,
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,118.31c0,.15-36.22.26-80.89.26s-80.89-.11-80.89-.26,36.21-.26,80.89-.26S227.06,118.17,227.06,118.31Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,127.87c0,.15-36.22.26-80.89.26s-80.89-.11-80.89-.26,36.21-.26,80.89-.26S227.06,127.73,227.06,127.87Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,137.43c0,.14-36.22.26-80.89.26s-80.89-.12-80.89-.26,36.21-.26,80.89-.26S227.06,137.28,227.06,137.43Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,147c0,.14-36.22.26-80.89.26s-80.89-.12-80.89-.26,36.21-.27,80.89-.27S227.06,146.84,227.06,147Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,156.54c0,.15-36.22.26-80.89.26s-80.89-.11-80.89-.26,36.21-.26,80.89-.26S227.06,156.4,227.06,156.54Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,145.41s-.12.15-.36.42a4.18,4.18,0,0,1-1.36.87,6.42,6.42,0,0,1-5.9-1.09,10.9,10.9,0,0,1-2.78-3.5c-.78-1.45-1.39-3.13-2.12-4.88a15.42,15.42,0,0,0-3.16-5.08,7,7,0,0,0-2.75-1.68,7.28,7.28,0,0,0-3.39-.18,12.92,12.92,0,0,0-6.45,3.42c-1.93,1.74-3.62,3.88-5.7,5.82a13,13,0,0,1-7.81,3.84,7.16,7.16,0,0,1-4.47-1.19,10.68,10.68,0,0,1-3.12-3.59c-1.61-2.78-2.42-6-4.51-8.54a7.36,7.36,0,0,0-3.92-2.71,5.43,5.43,0,0,0-4.6,1.1,10.59,10.59,0,0,0-3,4,25.79,25.79,0,0,0-1.43,5,30.61,30.61,0,0,1-1.42,5.22,12.53,12.53,0,0,1-1.3,2.45,11.85,11.85,0,0,1-1.91,2,12,12,0,0,1-4.94,2.46,11.64,11.64,0,0,1-5.44.08,12.26,12.26,0,0,1-4.81-2.37c-1.42-1.06-2.71-2.23-4.06-3.28a11.85,11.85,0,0,0-4.37-2.38,6.35,6.35,0,0,0-4.68.6,11,11,0,0,0-3.49,3.25,32,32,0,0,0-2.36,4.14,31.24,31.24,0,0,1-2.34,4.1,11,11,0,0,1-3.35,3.19,6.88,6.88,0,0,1-4.38,1,6.28,6.28,0,0,1-3.81-2.12,10.62,10.62,0,0,1-2.09-3.65,25.61,25.61,0,0,1-1-3.91c-.47-2.56-.93-5.06-2.25-7a8,8,0,0,0-5.2-3.87,5.84,5.84,0,0,0-3,.37,8.1,8.1,0,0,0-2.4,1.59c-2.73,2.61-4,5.77-6.07,7.6s-4,2.78-5.43,2.73a4.63,4.63,0,0,1-1.59-.28l-.49-.22a5.59,5.59,0,0,0,2.08.4c1.4,0,3.41-.88,5.29-2.77s3.24-5,6-7.67a8,8,0,0,1,2.49-1.66,6.11,6.11,0,0,1,3.16-.42,8.26,8.26,0,0,1,5.46,4,12.42,12.42,0,0,1,1.51,3.4c.35,1.22.58,2.49.82,3.77a26.3,26.3,0,0,0,1,3.84,10.43,10.43,0,0,0,2,3.5,5.91,5.91,0,0,0,3.55,2,6.36,6.36,0,0,0,4.08-1,10.4,10.4,0,0,0,3.21-3.06,31.06,31.06,0,0,0,2.29-4,31.52,31.52,0,0,1,2.39-4.21,11.54,11.54,0,0,1,3.65-3.4,6.8,6.8,0,0,1,5-.66,12.53,12.53,0,0,1,4.57,2.46c1.37,1.07,2.65,2.24,4,3.28a11.87,11.87,0,0,0,4.61,2.28,11.19,11.19,0,0,0,5.21-.08,11.62,11.62,0,0,0,4.72-2.36,10.13,10.13,0,0,0,1.82-1.94,11.36,11.36,0,0,0,1.25-2.33,30.27,30.27,0,0,0,1.4-5.14,25,25,0,0,1,1.47-5.13,10.79,10.79,0,0,1,3.18-4.22,5.92,5.92,0,0,1,5-1.19,7.8,7.8,0,0,1,4.19,2.89c2.17,2.64,3,5.92,4.55,8.61a10.19,10.19,0,0,0,3,3.44,6.74,6.74,0,0,0,4.18,1.13,12.6,12.6,0,0,0,7.55-3.71c2.05-1.9,3.75-4,5.72-5.8a13.31,13.31,0,0,1,6.66-3.49,7.7,7.7,0,0,1,3.55.22,7.39,7.39,0,0,1,2.88,1.77,15.58,15.58,0,0,1,3.2,5.21c.72,1.77,1.32,3.43,2.07,4.87a10.68,10.68,0,0,0,2.68,3.46,6.37,6.37,0,0,0,5.75,1.15A4.52,4.52,0,0,0,213,145.41Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,143.18l-.56,0c-.19,0-.42-.06-.69-.09a6.78,6.78,0,0,1-.9-.33,15.23,15.23,0,0,1-4.82-4.06q-.68-.78-1.38-1.68a18.18,18.18,0,0,0-1.49-1.84,7.88,7.88,0,0,0-4.76-2.17,6.64,6.64,0,0,0-2.91.36,7.61,7.61,0,0,0-2.59,1.75,60.23,60.23,0,0,0-4.26,5.51,12.74,12.74,0,0,1-2.73,2.65,8.49,8.49,0,0,1-3.73,1.4,16.77,16.77,0,0,1-8.21-1.54c-2.68-1.12-5.25-2.65-8.14-3.64a15.13,15.13,0,0,0-4.49-.9,9.84,9.84,0,0,0-4.53,1c-2.89,1.39-5.15,3.91-7.87,6a16.17,16.17,0,0,1-4.56,2.5,17,17,0,0,1-5.22.9A19.13,19.13,0,0,1,139,146.13a25.13,25.13,0,0,1-7.87-7.83c-2.11-3.16-3.26-6.74-4.78-10a20.26,20.26,0,0,0-2.79-4.56,12.15,12.15,0,0,0-4.1-3.17,7.36,7.36,0,0,0-4.94-.52,8.25,8.25,0,0,0-4.1,2.7A13.89,13.89,0,0,0,108,127a32.8,32.8,0,0,0-1.27,4.71c-.34,1.59-.64,3.16-1.07,4.7a21.14,21.14,0,0,1-1.76,4.37,19.86,19.86,0,0,1-5.94,6.7,17.39,17.39,0,0,1-7.75,3.13,16.28,16.28,0,0,1-7.66-.88,15.05,15.05,0,0,1-9.23-9.06c-.64-1.86-1-3.65-1.42-5.25A12.06,12.06,0,0,0,70,131.33a6.54,6.54,0,0,0-5.34-2.74,4.32,4.32,0,0,0-2,.73,3.53,3.53,0,0,1,2-.84,6.65,6.65,0,0,1,5.51,2.72,12.06,12.06,0,0,1,1.92,4.15c.48,1.61.82,3.4,1.46,5.22a14.79,14.79,0,0,0,9.09,8.81,15.93,15.93,0,0,0,7.48.84,17.09,17.09,0,0,0,7.55-3.09,19.37,19.37,0,0,0,5.78-6.57c1.5-2.66,2.13-5.77,2.77-8.95a33.84,33.84,0,0,1,1.28-4.78,14.4,14.4,0,0,1,2.54-4.42,8.79,8.79,0,0,1,4.35-2.86,7.84,7.84,0,0,1,5.28.55,12.51,12.51,0,0,1,4.28,3.3,20.86,20.86,0,0,1,2.87,4.67c1.54,3.32,2.68,6.85,4.75,10a24.61,24.61,0,0,0,7.7,7.67,18.69,18.69,0,0,0,10.08,2.8,16.6,16.6,0,0,0,5.07-.87,15.69,15.69,0,0,0,4.42-2.41c2.67-2,5-4.57,8-6a10.24,10.24,0,0,1,4.75-1,15.5,15.5,0,0,1,4.63.94c2.94,1,5.52,2.57,8.16,3.67a16.42,16.42,0,0,0,8,1.54,8.2,8.2,0,0,0,3.57-1.32,12.39,12.39,0,0,0,2.65-2.56,59.74,59.74,0,0,1,4.32-5.52,7.89,7.89,0,0,1,2.71-1.8,7,7,0,0,1,3-.36,8.13,8.13,0,0,1,4.91,2.28,18.69,18.69,0,0,1,1.5,1.88c.46.6.91,1.17,1.36,1.69a15.59,15.59,0,0,0,4.7,4.1A4.16,4.16,0,0,0,223.21,143.18Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,118.79a4.69,4.69,0,0,1-2.14.26,4.69,4.69,0,0,1-2.14-.26,4.69,4.69,0,0,1,2.14-.26A4.69,4.69,0,0,1,54.17,118.79Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,127.87a4.54,4.54,0,0,1-2.14.26,4.54,4.54,0,0,1-2.14-.26,4.69,4.69,0,0,1,2.14-.26A4.69,4.69,0,0,1,54.17,127.87Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,137a4.54,4.54,0,0,1-2.14.26,4.54,4.54,0,0,1-2.14-.26,4.69,4.69,0,0,1,2.14-.26A4.69,4.69,0,0,1,54.17,137Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,146a4.69,4.69,0,0,1-2.14.26,4.69,4.69,0,0,1-2.14-.26,4.54,4.54,0,0,1,2.14-.26A4.54,4.54,0,0,1,54.17,146Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,155.12a4.69,4.69,0,0,1-2.14.26,4.69,4.69,0,0,1-2.14-.26,4.54,4.54,0,0,1,2.14-.26A4.54,4.54,0,0,1,54.17,155.12Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,166.79a18,18,0,0,1-4.27.26,18,18,0,0,1-4.28-.26,18,18,0,0,1,4.28-.26A18,18,0,0,1,73.83,166.79Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.56,166.79a18.09,18.09,0,0,1-4.28.26,18.09,18.09,0,0,1-4.28-.26,18.09,18.09,0,0,1,4.28-.26A18.09,18.09,0,0,1,111.56,166.79Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,166.79a18.09,18.09,0,0,1-4.28.26,18.09,18.09,0,0,1-4.28-.26,18.09,18.09,0,0,1,4.28-.26A18.09,18.09,0,0,1,149.28,166.79Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,166.79a18,18,0,0,1-4.28.26,18,18,0,0,1-4.27-.26,18,18,0,0,1,4.27-.26A18,18,0,0,1,187,166.79Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,166.79a35.36,35.36,0,0,1-8.56,0,35.36,35.36,0,0,1,8.56,0Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.52,
    y: 307.31,
    width: 173.5,
    height: 107.39,
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.14,385c-12-4.56-25.87,8.05-37.66,2.91-6.87-3-10-10.76-13.34-17.45s-9.16-13.74-16.61-13-13.58,9.48-20.84,7.39c-4.57-1.33-6.85-6.4-8-11s-1.94-9.72-5.43-13-10.75-2.38-11.3,2.35v56.93H496.65S478.3,386.53,474.14,385Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.27,400.13c0,.12-32.89.22-73.45.22s-73.45-.1-73.45-.22,32.88-.22,73.45-.22S500.27,400,500.27,400.13Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.27,375.27c0,.12-32.89.22-73.45.22s-73.45-.1-73.45-.22,32.88-.23,73.45-.23S500.27,375.14,500.27,375.27Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.27,350.4c0,.12-32.89.22-73.45.22s-73.45-.1-73.45-.22,32.88-.22,73.45-.22S500.27,350.28,500.27,350.4Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.27,326.77c0,.12-32.89.22-73.45.22s-73.45-.1-73.45-.22,32.88-.22,73.45-.22S500.27,326.65,500.27,326.77Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.21,
    y: 51.01,
    width: 129.14,
    height: 115.54,
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.36,166.55s0-.75,0-2.15,0-3.49,0-6.19c0-5.42,0-13.35-.08-23.45,0-20.19-.08-49-.15-83.75l.3.29-129.14.05h0l.35-.34c0,42,0,81.59,0,115.54l-.31-.31,93.41.16,26.34.08,7,0,1.8,0c.4,0,.62,0,.62,0h-.59l-1.77,0-6.91,0-26.28.08-93.6.15h-.3v-.3c0-34,0-73.51,0-115.54v-.35h.35l129.14.05h.29V51c-.06,34.79-.12,63.7-.15,83.93,0,10.07-.06,18-.08,23.39,0,2.68,0,4.73,0,6.13S656.36,166.55,656.36,166.55Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.73,71.54c0,.19-6.8.34-15.18.34s-15.18-.15-15.18-.34,6.79-.35,15.18-.35S576.73,71.34,576.73,71.54Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.45,80.21c0,.19-18.67.35-41.71.35S548,80.4,548,80.21s18.67-.34,41.7-.34S631.45,80,631.45,80.21Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.98,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.62,
    y: 94.66,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.77,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.55,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.95,
    y: 94.91,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.98,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.37,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.77,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.8,
    y: 106.23,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.95,
    y: 106.47,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.23,
    y: 117.79,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.37,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.77,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.55,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.95,
    y: 118.04,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.98,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.37,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.01,
    y: 129.36,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.55,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.95,
    y: 129.61,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.59,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.98,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.37,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.77,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.16,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.8,
    y: 140.93,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.95,
    y: 141.17,
    width: 5.44,
    height: 5.44,
    style: {
      fill: "#475569"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M726.91,478.44c0,.14-153.11.26-341.94.26s-342-.12-342-.26,153.07-.26,342-.26S726.91,478.3,726.91,478.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Panel--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.17,61.46s15.29.21,8.75,30.49-5.7,36-5.7,48A20.89,20.89,0,0,0,490.53,159H469.79L454.54,88.31V61.46Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.67 299.79 271.28 299.79 273.15 94.94 470.37 84.63 480.67 299.79",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.48 294.5 264.09 294.5 265.96 89.65 469.27 85.68 473.48 294.5",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.14 288.79 260.18 288.79 260.18 83.94 469.27 83.45 469.14 288.79",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.14,288.79c0-1.91,0-82.17-.1-205.34l.23.23-208.76.52h-.33l.26-.26c0,74.94,0,145.21,0,204.85l-.22-.22,209,.22-209,.23H260v-.23c0-59.64,0-129.91,0-204.85v-.26h.58l208.77-.45h.22v.22C469.28,206.62,469.14,286.88,469.14,288.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27,82.9c-10.8-12.57,1.73-21.87,6-22.07l-199-.11a16.76,16.76,0,0,0-16.53,19.62,23.83,23.83,0,0,0,.81,3.11",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.54,159l.28,0,.8,0,3.12,0,11.79-.07,0,.31a12.77,12.77,0,0,1-4.81-2.75,15.69,15.69,0,0,1-3.58-5.12,34.12,34.12,0,0,1-2.15-6.54c-.27-1.17-.51-2.36-.73-3.58a18.69,18.69,0,0,1-.29-1.87,15.22,15.22,0,0,1-.14-1.92,69.3,69.3,0,0,1,.26-8c.2-2.72.51-5.51.84-8.36.68-5.69,1.53-11.62,2.54-17.7.42-2.59.94-5.16,1.37-7.67s.75-5,1.07-7.48.58-4.88.87-7.25c.13-1.18.29-2.35.32-3.5a21.4,21.4,0,0,0-.19-3.41A20.66,20.66,0,0,0,484,67.74,12.48,12.48,0,0,0,480.15,63a7.52,7.52,0,0,0-5.44-1.21,9.87,9.87,0,0,0-4.84,2,12,12,0,0,0-3,3.74,16,16,0,0,0-1.46,4.07,10.64,10.64,0,0,0,.79,6.78,23.48,23.48,0,0,0,2.2,3.83l.68.93c.15.21.22.33.22.33s-.1-.09-.27-.29l-.71-.91a20.76,20.76,0,0,1-2.3-3.81,10.82,10.82,0,0,1-.9-6.92,16.31,16.31,0,0,1,1.46-4.16,12.27,12.27,0,0,1,3.09-3.88,10.38,10.38,0,0,1,5-2.12,7.94,7.94,0,0,1,5.74,1.26,12.84,12.84,0,0,1,4,4.91A20.84,20.84,0,0,1,486.33,74a22.41,22.41,0,0,1,.21,3.49c0,1.19-.19,2.36-.32,3.55-.26,2.37-.54,4.79-.86,7.26s-.65,5-1.06,7.5-.95,5.07-1.36,7.67c-1,6.07-1.87,12-2.56,17.67-.33,2.84-.64,5.62-.85,8.34a71,71,0,0,0-.29,7.9,16.48,16.48,0,0,0,.13,1.88c.05.62.18,1.24.28,1.85.22,1.21.45,2.4.72,3.56a33.58,33.58,0,0,0,2.08,6.47,15.44,15.44,0,0,0,3.47,5,12.37,12.37,0,0,0,4.66,2.71l1,.32h-1l-11.79-.07-3.12,0-.8,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,67.09c.08.06-.52.85-1.11,2.31a13.43,13.43,0,0,0-.75,2.63,15.16,15.16,0,0,0-.16,3.35,14.53,14.53,0,0,0,.67,3.28,13.06,13.06,0,0,0,1.14,2.5c.81,1.34,1.52,2,1.45,2.11s-.22-.14-.54-.45a8.31,8.31,0,0,1-1.22-1.47,11.66,11.66,0,0,1-1.28-2.53,12.7,12.7,0,0,1-.53-6.87,12.05,12.05,0,0,1,.88-2.7,8.34,8.34,0,0,1,1-1.64C345.47,67.26,345.64,67.07,345.67,67.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.7,60a20.88,20.88,0,0,0-2.64,3.23,13.22,13.22,0,0,0,3.33,17.86A21.37,21.37,0,0,0,345,83.16a4.68,4.68,0,0,1-1.1-.3,12.09,12.09,0,0,1-2.75-1.46A13.19,13.19,0,0,1,337.75,63a11.79,11.79,0,0,1,2-2.35A4.17,4.17,0,0,1,340.7,60Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.16,219.92l-.65,0-1.92,0-7.39.05L416,220.1l-89.61.08h-38.9v-.25c0-25.6.07-47.62.1-63.26,0-7.8.05-14,.07-18.28,0-2.11,0-3.75,0-4.88,0-.54,0-.95,0-1.25s0-.43,0-.43,0,.14,0,.43,0,.71,0,1.25c0,1.13,0,2.77,0,4.88,0,4.28,0,10.48.07,18.28,0,15.64.06,37.66.1,63.26l-.25-.25h38.65l89.61.08,27.16.08,7.39.05,1.92,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.22,
    y: 198.15,
    width: 16.71,
    height: 16.71,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.71,
    y: 186.21,
    width: 16.71,
    height: 28.65,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.3,
    y: 172.64,
    width: 16.71,
    height: 42.22,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.14,
    y: 157.54,
    width: 16.71,
    height: 57.32,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.53,
    y: 138.21,
    width: 16.71,
    height: 76.65,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.74,
    y: 123.46,
    width: 16.71,
    height: 90.61,
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.22,181a1.06,1.06,0,0,1,.21-.17l.65-.45,2.55-1.7,9.57-6.31,33.15-21.67.39-.25v.46c0,2.37,0,4.9,0,7.48l-.4-.21,13.06-8.76,46.1-30.8,14-9.29,3.82-2.5,1-.64.35-.2a2.19,2.19,0,0,1-.32.24l-1,.69-3.77,2.58L406.72,119l-46,30.93-13.07,8.75-.4.27v-8l.39.21-33.26,21.51-9.65,6.19-2.59,1.63-.67.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.69,113.09a8.57,8.57,0,0,1-.18-2.06c0-1.28-.07-3.06-.08-5l.26.26h-.64c-2.14,0-4.08,0-5.48-.08a10.48,10.48,0,0,1-2.27-.18,10,10,0,0,1,2.27-.19c1.4,0,3.34-.07,5.48-.07h.9V106c0,2,0,3.77-.08,5A8.57,8.57,0,0,1,425.69,113.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,233.39c0,.15-5.16.26-11.53.26s-11.53-.11-11.53-.26,5.16-.26,11.53-.26S337.41,233.25,337.41,233.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.57,241.29a14.15,14.15,0,0,1,0-5.4,14.15,14.15,0,0,1,0,5.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,244c0,.14-13.87.26-31,.26s-31-.12-31-.26,13.86-.26,31-.26S353.83,243.85,353.83,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,251.68a27,27,0,0,1,0-7.48,27,27,0,0,1,0,7.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,250.85a20.07,20.07,0,0,1,0-6.44,20.07,20.07,0,0,1,0,6.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,251.26a24.09,24.09,0,0,1,0-7.06,24.09,24.09,0,0,1,0,7.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24,251.26a25.54,25.54,0,0,1,0-7.27,25.54,25.54,0,0,1,0,7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,253.76a54.72,54.72,0,0,1-7.48.26,54.72,54.72,0,0,1-7.48-.26,52.86,52.86,0,0,1,7.48-.26A52.86,52.86,0,0,1,300,253.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.13,253.76a62.94,62.94,0,0,1-11.43,0,62.94,62.94,0,0,1,11.43,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,254.38a72.39,72.39,0,0,1-12.26,0,72.39,72.39,0,0,1,12.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,253.34a82.51,82.51,0,0,1-13.09,0,82.51,82.51,0,0,1,13.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.53,261a9.27,9.27,0,0,1,0-4.36,9.27,9.27,0,0,1,0,4.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,261c0,.14-6.05.26-13.5.26s-13.51-.12-13.51-.26,6.05-.26,13.51-.26S306.75,260.88,306.75,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,267.26a18.79,18.79,0,0,1,0-6.23,18.79,18.79,0,0,1,0,6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,267.68a21.39,21.39,0,0,1,0-6.65,21.39,21.39,0,0,1,0,6.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,261a9.27,9.27,0,0,1,0-4.36,9.27,9.27,0,0,1,0,4.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39,261c0,.14-10.22.26-22.82.26s-22.81-.12-22.81-.26,10.21-.26,22.81-.26S370.39,260.88,370.39,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.77,267.26a18.79,18.79,0,0,1,0-6.23,18.79,18.79,0,0,1,0,6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,267.26a18.79,18.79,0,0,1,0-6.23,18.79,18.79,0,0,1,0,6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,267.68a21.39,21.39,0,0,1,0-6.65,21.39,21.39,0,0,1,0,6.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,271.51a54.56,54.56,0,0,1-10.64,0,54.56,54.56,0,0,1,10.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.52,270.75a63.82,63.82,0,0,1-11.51,0,63.82,63.82,0,0,1,11.51,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.63,270.75a49.47,49.47,0,0,1-10.13,0,49.47,49.47,0,0,1,10.13,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,270.75a58.2,58.2,0,0,1-11,0,58.2,58.2,0,0,1,11,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,270.06a60,60,0,0,1-11.16,0,60,60,0,0,1,11.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,274.11H382.47V230.43H453Zm-70.49-.05H453V230.48H382.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,262c-4.89-1.85-10.51,3.27-15.31,1.18-2.78-1.21-4.05-4.37-5.42-7.08s-3.72-5.59-6.74-5.27-5.52,3.85-8.47,3c-1.86-.54-2.78-2.6-3.25-4.48s-.79-3.95-2.21-5.27-4.36-1-4.59,1v23.13h55.13S437.66,262.64,436,262Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.58,268.17c0,.05-13.36.09-29.84.09s-29.84,0-29.84-.09,13.36-.09,29.84-.09S446.58,268.12,446.58,268.17Z",
    style: {
      fill: "#475569"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.58,258.07c0,.05-13.36.09-29.84.09s-29.84,0-29.84-.09,13.36-.09,29.84-.09S446.58,258,446.58,258.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.58,248s-13.36.08-29.84.08-29.84,0-29.84-.08,13.36-.09,29.84-.09S446.58,247.92,446.58,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.58,238.36s-13.36.09-29.84.09-29.84,0-29.84-.09,13.36-.09,29.84-.09S446.58,238.31,446.58,238.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.79,98.29s0,0,.1,0h.28a5.77,5.77,0,0,1,1.1.1,5.65,5.65,0,0,1,1.66.57,5.38,5.38,0,0,1,1.77,1.52,6.28,6.28,0,0,1,1.17,2.6,6.2,6.2,0,0,1-.41,3.25,9.62,9.62,0,0,1-.81,1.6,16.92,16.92,0,0,0-.91,1.62,13.7,13.7,0,0,0-1.22,3.71l0,.09h-.09l-2.61-.06-2.74-.07H285v-.1a7.83,7.83,0,0,0-1.13-3.66c-.29-.56-.62-1.08-.93-1.61a15.64,15.64,0,0,1-.86-1.55,5.09,5.09,0,0,1-.29-3.24,6.8,6.8,0,0,1,1.13-2.59A5,5,0,0,1,284.67,99a6.18,6.18,0,0,1,1.65-.56,6.42,6.42,0,0,1,1.09-.14h.28c.07,0,.1,0,.1,0h-.1l-.28,0a6.84,6.84,0,0,0-1.07.17,6.53,6.53,0,0,0-1.62.58,5.08,5.08,0,0,0-1.73,1.47,6.71,6.71,0,0,0-1.07,2.55,4.89,4.89,0,0,0,.29,3.13,15.84,15.84,0,0,0,.86,1.53c.31.52.64,1.05.94,1.61a7.91,7.91,0,0,1,1.15,3.76l-.09-.11,2.74.07,2.61.07-.1.08a14.2,14.2,0,0,1,1.24-3.76,16.92,16.92,0,0,1,.93-1.63,9.3,9.3,0,0,0,.8-1.57,5.92,5.92,0,0,0,.42-3.17,6.26,6.26,0,0,0-1.11-2.54A5.55,5.55,0,0,0,290.88,99a5.87,5.87,0,0,0-1.62-.59,7.35,7.35,0,0,0-1.09-.13l-.29,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,113a.62.62,0,0,0,0-.09l0-.24c0-.22-.06-.54-.11-1-.08-.83-.21-2-.27-3.51,0-.37,0-.76,0-1.16s0-.83,0-1.27a3.5,3.5,0,0,1,.35-1.31,2.07,2.07,0,0,1,1.05-1,1.35,1.35,0,0,1,1.43.34,1,1,0,0,1,.28.73,1.31,1.31,0,0,1-.3.75,1.9,1.9,0,0,1-.66.49,3.58,3.58,0,0,1-.79.23,10.52,10.52,0,0,1-3.36,0,2.66,2.66,0,0,1-.78-.26,2,2,0,0,1-.65-.5,1.54,1.54,0,0,1-.36-.72,1.23,1.23,0,0,1,.13-.78,1.09,1.09,0,0,1,.58-.52.94.94,0,0,1,.75.07,1.37,1.37,0,0,1,.54.5,1.88,1.88,0,0,1,.25.67,7.82,7.82,0,0,1,.08,1.35c0,.87,0,1.69,0,2.43,0,1.48,0,2.68,0,3.51v1.29a.45.45,0,0,0,0-.08v-.25q0-.33,0-1c0-.83,0-2-.06-3.51,0-.74,0-1.55,0-2.43a7.65,7.65,0,0,0-.08-1.34,1.84,1.84,0,0,0-.24-.64,1.31,1.31,0,0,0-.52-.47.83.83,0,0,0-.69-.06,1,1,0,0,0-.53.48,1.11,1.11,0,0,0-.12.72,1.54,1.54,0,0,0,.34.69,2.39,2.39,0,0,0,1.39.73,9.15,9.15,0,0,0,1.66.15,8.33,8.33,0,0,0,1.66-.13,2.91,2.91,0,0,0,.78-.22,1.8,1.8,0,0,0,.63-.46,1.23,1.23,0,0,0,.28-.7.9.9,0,0,0-.26-.68,1.27,1.27,0,0,0-1.34-.32,1.94,1.94,0,0,0-1,.94,3.27,3.27,0,0,0-.35,1.28c0,.43,0,.85-.05,1.26s0,.79,0,1.16c.05,1.48.17,2.68.24,3.5,0,.41.07.73.1,1l0,.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,113s0,.33,0,.88,0,1.4,0,2.29l0,0,1.7,2.12-.09,0,2.06,0-.08,0,1.07-1.21.54-.6,0,.08c0-1.21,0-2.35.06-3.39l.11.11-3.85-.12-1.11,0-.41,0a1.34,1.34,0,0,1,.36,0l1.09,0h4v.11c0,1,0,2.18,0,3.39v0l0,0-.54.61-1.07,1.2,0,0h-.05l-2.07,0h0l0,0L285,116.26l0,0v0c0-.91.05-1.69.07-2.35A5.41,5.41,0,0,1,285.07,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26,116.22l-.2-.09a4,4,0,0,0-.52-.23,5.1,5.1,0,0,0-1.85-.36,5.17,5.17,0,0,0-1.85.32,4.54,4.54,0,0,0-.53.22l-.2.09a.74.74,0,0,1,.18-.12l.53-.25a5.19,5.19,0,0,1,1.87-.35,5.07,5.07,0,0,1,1.87.39,4.94,4.94,0,0,1,.52.26A.74.74,0,0,1,290.26,116.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,115.4l-.19-.1-.53-.23a5.56,5.56,0,0,0-1.85-.36,5.38,5.38,0,0,0-1.85.33,4.54,4.54,0,0,0-.53.22l-.19.08.18-.11a3.2,3.2,0,0,1,.52-.25,5,5,0,0,1,1.88-.35,5.06,5.06,0,0,1,1.86.39,3.54,3.54,0,0,1,.52.26A.74.74,0,0,1,290.29,115.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,114.61a.94.94,0,0,1-.19-.09,4.29,4.29,0,0,0-.53-.23,5.2,5.2,0,0,0-3.7,0c-.22.08-.4.16-.53.22l-.19.09.18-.12c.12-.06.3-.15.52-.24a4.88,4.88,0,0,1,1.88-.35,4.93,4.93,0,0,1,1.87.38c.22.1.4.19.52.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,136.14s-2,18.45.57,28.55l24.65-1.08s-5.28-18.19-2-26.25Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.47,135.55s.17,19.92,1.18,26l25-1.18s-2.2-19.58-1.35-24.81Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.51,143.92c0,.09-3.74.39-8.37.67s-8.38.43-8.39.33,3.74-.39,8.37-.67S330.51,143.82,330.51,143.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,148.13c0,.1-3.74.4-8.37.67s-8.39.43-8.39.34,3.74-.39,8.37-.67S330.51,148,330.52,148.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,152.28a6.15,6.15,0,0,1-1.39.2c-.86.08-2.05.17-3.37.25s-2.52.13-3.38.15a5.37,5.37,0,0,1-1.41,0,5.63,5.63,0,0,1,1.39-.2c.87-.08,2.06-.17,3.38-.25s2.51-.14,3.38-.16A5.49,5.49,0,0,1,326.27,152.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,103.21c0,.15-14.61.26-32.63.26s-32.63-.11-32.63-.26,14.61-.26,32.63-.26S366.42,103.07,366.42,103.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.13,109.16c0,.15-5.48.26-12.24.26s-12.24-.11-12.24-.26,5.48-.26,12.24-.26S325.13,109,325.13,109.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.13,109.16a43,43,0,0,1-9.44,0,43,43,0,0,1,9.44,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.54,171.9a.89.89,0,0,1,0-.23c0-.18,0-.4-.06-.67-.05-.63-.12-1.49-.21-2.57-.15-2.29-.37-5.51-.64-9.47-.5-8.05-1.19-19.08-1.95-31.27s-1.32-23.23-1.79-31.28c-.2-4-.36-7.19-.48-9.48,0-1.08-.08-1.94-.1-2.58,0-.27,0-.49,0-.67a.6.6,0,0,1,0-.23,2.32,2.32,0,0,1,0,.23l.06.67c.05.63.12,1.49.2,2.57.16,2.29.38,5.51.65,9.47.5,8,1.19,19.08,1.94,31.27s1.33,23.23,1.79,31.27c.21,4,.37,7.2.49,9.49,0,1.08.08,1.94.1,2.58,0,.27,0,.49,0,.67A.6.6,0,0,1,474.54,171.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27,60.83l-.58,0-1.7,0-6.55,0-24.05,0L357,60.84l-82.15-.26h0a19.78,19.78,0,0,0-10.44,6.51,19.25,19.25,0,0,0-4.06,8.38,20.35,20.35,0,0,0-.39,5.89c.06.67.12,1.18.18,1.52a4.93,4.93,0,0,1,.07.52,13.14,13.14,0,0,1-.35-2,19.67,19.67,0,0,1,.3-5.94,19.33,19.33,0,0,1,4-8.51,20,20,0,0,1,10.58-6.68h0l82.16.1,79.35.25,24.06.14,6.54.06,1.7,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.87,374.41a54.77,54.77,0,0,1,52.23-14.33,95.14,95.14,0,0,1-52.85,16.51",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.59,311.68c-2.18-15.39,3.8-32.7,15.32-43.89.38,15.25-6,32.42-15.32,43.89",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.37,340.76a82.15,82.15,0,0,1,37.74-36.07,51.85,51.85,0,0,1-37.88,36.23",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.46,346.36c9.3.27,18.71-.06,27.7-2.44s17.6-6.95,23.58-14.07a92.55,92.55,0,0,0-51.14,15.61",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.18,327.89c-4.72-17.69-12.5-29.92-26.4-39.83a36.77,36.77,0,0,0,26.4,39.83",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.09,358.39A26.19,26.19,0,0,1,622,334.14c-.78,9.13-8,19.7-15.91,24.25",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.65,343.48A39,39,0,0,0,576.1,310.2c3.21,14.78,11.75,27.08,25.55,33.28",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.34,369.94c-3.27-4.69-8.62-7.61-14.16-9.06s-11.32-1.57-17-1.69A39.86,39.86,0,0,0,607.91,372",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,407.63a43.65,43.65,0,0,0-53.3,25.25c19.36-3.68,38.47-12.28,53.3-25.25",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.24,394.53c-3.22,9.51-2.6,21,4.55,29.19a34.88,34.88,0,0,0-4.55-29.19",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.8,389.25a35.77,35.77,0,0,0,19.75,29,2.25,2.25,0,0,0,1.75.29c.87-.36,1-1.55.84-2.48-1.4-12.18-10.42-24-22.34-26.83",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657,388a29.33,29.33,0,0,0,42.85.22c-13.62-1.49-29.34-2.48-42.85-.22",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,279.13a2.55,2.55,0,0,1-.13.4l-.41,1.16c-.39,1-.94,2.51-1.64,4.41s-1.58,4.26-2.56,7c-.5,1.36-1,2.82-1.58,4.37s-1.1,3.2-1.7,4.93c-2.41,6.89-5.09,15.17-8,24.39s-5.82,19.42-8.75,30.18-5.46,21.07-7.65,30.49-4,17.93-5.27,25.11c-.33,1.8-.66,3.51-1,5.12s-.54,3.16-.78,4.59c-.49,2.86-.92,5.32-1.2,7.34s-.55,3.56-.71,4.65c-.09.52-.15.92-.2,1.21a2.39,2.39,0,0,1-.09.41,2.11,2.11,0,0,1,0-.41l.15-1.22c.15-1.09.35-2.66.62-4.67s.65-4.49,1.11-7.36c.23-1.44.48-3,.74-4.59s.61-3.34.93-5.13c1.28-7.2,3.07-15.72,5.16-25.16s4.72-19.74,7.61-30.52,5.94-20.95,8.81-30.18,5.63-17.49,8.09-24.37l1.74-4.92L654,292c1-2.73,1.88-5.07,2.65-7s1.32-3.35,1.73-4.37c.2-.48.35-.86.46-1.14A2.73,2.73,0,0,1,659,279.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.23,318.09a1.43,1.43,0,0,1,.23.22l.66.69c.56.6,1.39,1.51,2.42,2.71a97.32,97.32,0,0,1,8,10.69,71.75,71.75,0,0,1,8.38,17.94c2.25,7.14,3.64,15.26,5,23.74,2.77,17,6.17,32.19,8.63,43.19,1.24,5.48,2.24,9.92,2.95,13,.33,1.51.59,2.7.78,3.54l.19.93a1.47,1.47,0,0,1,.05.32,2,2,0,0,1-.1-.31l-.24-.91c-.21-.84-.51-2-.88-3.53-.74-3.1-1.8-7.53-3.11-13-2.55-11-6-26.2-8.78-43.2-1.39-8.48-2.77-16.57-5-23.68a72.52,72.52,0,0,0-8.24-17.88,101.07,101.07,0,0,0-7.86-10.76c-1-1.22-1.8-2.14-2.34-2.77l-.62-.72C584.29,318.19,584.22,318.1,584.23,318.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.07,387.43a1.68,1.68,0,0,1-.49.09l-1.41.16-1,.1L657,388c-.87.13-1.86.26-2.93.49l-1.69.34-1.81.46c-1.26.28-2.56.75-3.95,1.17a57.66,57.66,0,0,0-8.63,3.8,48.43,48.43,0,0,0-7.73,5.37,38.65,38.65,0,0,0-3,2.84,30.17,30.17,0,0,0-2.35,2.71,27.13,27.13,0,0,0-1.74,2.4,16.38,16.38,0,0,0-1.19,1.89l-.72,1.22c-.17.28-.27.42-.29.41a2.25,2.25,0,0,1,.19-.46c.18-.34.39-.76.64-1.27a16.8,16.8,0,0,1,1.13-1.95,24.35,24.35,0,0,1,1.69-2.46,28.69,28.69,0,0,1,2.32-2.78,37.51,37.51,0,0,1,3-2.92,46.77,46.77,0,0,1,7.79-5.46,55.21,55.21,0,0,1,8.73-3.8c1.4-.41,2.72-.86,4-1.13l1.84-.43,1.7-.31c1.09-.21,2.09-.32,3-.42l1.21-.14,1,0,1.42-.06A2.38,2.38,0,0,1,661.07,387.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,318.42a7.12,7.12,0,0,1-1,.94l-2.81,2.44c-2.38,2-5.69,4.82-9.37,7.87s-7,5.79-9.48,7.75l-2.91,2.31a6.54,6.54,0,0,1-1.11.79,6.58,6.58,0,0,1,1-.95l2.8-2.43c2.38-2,5.7-4.82,9.38-7.87s7-5.79,9.46-7.76l2.91-2.3A6.08,6.08,0,0,1,665,318.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.3,336.43c0,.14-7.11,2.38-16,5s-16.08,4.62-16.12,4.49,7.1-2.38,16-5S668.26,336.3,668.3,336.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.89,329.26a6.27,6.27,0,0,1-.74-1l-1.88-2.88c-1.6-2.42-3.87-5.72-6.56-9.23s-5.27-6.57-7.18-8.76l-2.26-2.58a5.47,5.47,0,0,1-.79-1,6.66,6.66,0,0,1,.94.85c.58.57,1.4,1.41,2.39,2.48,2,2.12,4.62,5.16,7.32,8.68s4.92,6.88,6.45,9.35c.76,1.24,1.36,2.26,1.75,3A5.87,5.87,0,0,1,641.89,329.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.06,339.26a23.35,23.35,0,0,1-1.68,2.76c-1.07,1.68-2.52,4-4,6.65s-2.77,5.08-3.67,6.86a23.2,23.2,0,0,1-1.51,2.85,17.57,17.57,0,0,1,1.18-3c.82-1.82,2-4.3,3.55-7s3-5,4.16-6.59A16.23,16.23,0,0,1,617.06,339.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.56,370.43c0,.07-1.4-.6-3.64-1.6s-5.35-2.32-8.87-3.56-6.78-2.15-9.15-2.75-3.86-.94-3.84-1a4.91,4.91,0,0,1,1.06.11c.68.1,1.66.29,2.86.55a77.84,77.84,0,0,1,9.24,2.62,79.53,79.53,0,0,1,8.86,3.71c1.1.55,2,1,2.58,1.36A4.25,4.25,0,0,1,608.56,370.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.25,407.69a2,2,0,0,1-.44.15l-1.29.32-4.76,1.1a157.21,157.21,0,0,0-15.53,4.1,68.92,68.92,0,0,0-14.49,6.81c-1.74,1.1-3.09,2.08-4,2.78A11,11,0,0,1,573.3,424a2.06,2.06,0,0,1,.32-.33c.23-.21.55-.52,1-.89a42.52,42.52,0,0,1,3.91-2.93,63.43,63.43,0,0,1,14.53-7,129.41,129.41,0,0,1,15.63-4l4.79-.93A10.09,10.09,0,0,1,615.25,407.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.44,416.87c-.15,0-1-5-1.9-11.2s-1.53-11.26-1.39-11.28,1,5,1.9,11.2S639.58,416.85,639.44,416.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.62,407.73a27.71,27.71,0,0,1-2.27-2.7c-1.36-1.69-3.25-4-5.38-6.57s-4.11-4.79-5.54-6.43a24.2,24.2,0,0,1-2.26-2.7,3.93,3.93,0,0,1,.72.62c.44.42,1.06,1.05,1.81,1.84,1.51,1.57,3.53,3.79,5.67,6.34s4,4.92,5.27,6.68c.65.87,1.16,1.59,1.5,2.1A2.9,2.9,0,0,1,664.62,407.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.97 431.08 597.97 443.53 601.09 443.53 612.15 478.44 636.68 478.44 647.39 443.87 651.54 443.53 651.54 431.08 597.97 431.08",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.47,443.87c0,.15-10.84.26-24.19.26s-24.2-.11-24.2-.26,10.83-.26,24.2-.26S649.47,443.73,649.47,443.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.11,363.83a11.74,11.74,0,0,1-1.57.42l-4.31,1c-3.63.9-8.61,2.26-14,4.08s-10.2,3.74-13.63,5.22l-4.06,1.78A10.48,10.48,0,0,1,628,377a8.8,8.8,0,0,1,1.42-.8c.93-.48,2.3-1.14,4-1.93a143,143,0,0,1,27.72-9.32c1.82-.4,3.31-.7,4.34-.88A9.87,9.87,0,0,1,667.11,363.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.32,463.26c0,.14-7.6.26-17,.26s-17-.12-17-.26,7.6-.26,17-.26S641.32,463.12,641.32,463.26Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.28,460.37c0,.15-8.06.26-18,.26s-18-.11-18-.26,8.06-.26,18-.26S642.28,460.23,642.28,460.37Z",
    style: {
      fill: "#1e293b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.29,446.69l-1.63,20.53s-20.28,6.52-20.4,10.32l39.68.52,1.17-31.41Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.89,465.13a1.63,1.63,0,0,1,1.18,1.82,1.57,1.57,0,0,1-1.79,1.18A1.71,1.71,0,0,1,501,466.2a1.61,1.61,0,0,1,2-1",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.94,478.06l-.08-3.18-37.58.23s-2.15,1.28-2.09,2.52Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,467c0,.19,1,.25,2,.85s1.51,1.39,1.68,1.31-.14-1.2-1.33-1.9S490,466.86,490,467Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.9,468.89c0,.19.81.49,1.49,1.29s.9,1.66,1.1,1.65.28-1.12-.59-2.1S485.9,468.7,485.9,468.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.68,473.94c.18,0,.42-.94-.11-2s-1.45-1.44-1.52-1.27.5.71.92,1.58S483.49,473.93,483.68,473.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.22,462.35c.09.17,1-.12,2.07-.08s2,.36,2.06.19-.75-.84-2-.87S490.12,462.2,490.22,462.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,458.22a3.67,3.67,0,0,0,2-.07,8.71,8.71,0,0,0,2.07-.7,9.13,9.13,0,0,0,1.12-.64,2.72,2.72,0,0,0,.59-.49.85.85,0,0,0,0-1,1.06,1.06,0,0,0-.86-.42,2.58,2.58,0,0,0-.74.13,7.46,7.46,0,0,0-1.23.46,6.72,6.72,0,0,0-1.79,1.26c-.9.88-1.19,1.61-1.12,1.65s.52-.56,1.43-1.3a8.34,8.34,0,0,1,1.75-1.05,7.49,7.49,0,0,1,1.13-.38c.41-.13.77-.14.89,0s0,.1,0,.23a2.38,2.38,0,0,1-.43.35,9.61,9.61,0,0,1-1,.63,10.68,10.68,0,0,1-1.9.8A14.41,14.41,0,0,0,490,458.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.29,458.49a3.17,3.17,0,0,0,.46-1.94,6.44,6.44,0,0,0-.33-2.17,7.4,7.4,0,0,0-.55-1.19,1.63,1.63,0,0,0-1.3-1,.91.91,0,0,0-.81.58,2.77,2.77,0,0,0-.18.73,4.26,4.26,0,0,0,0,1.34,4.6,4.6,0,0,0,.91,2c.81,1,1.62,1.21,1.64,1.15s-.63-.46-1.25-1.43a4.55,4.55,0,0,1-.69-1.85,4.42,4.42,0,0,1,0-1.15c0-.42.2-.77.36-.73s.54.3.72.63a7.4,7.4,0,0,1,.52,1.06,7.49,7.49,0,0,1,.45,2C490.37,457.73,490.18,458.46,490.29,458.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.09,443.27l4.58,24,9.1,17.92a2.5,2.5,0,0,1-1.25,3.43h0a2.48,2.48,0,0,1-2.29-.17c-4.39-2.71-20.5-12.75-20.74-14.53-.27-2-6.52-25-6.52-25Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.52,488.6l-23.38-16.31.22,1a3.75,3.75,0,0,0,1.39,2.2c1.9,1.46,7.23,5.36,19.41,12.95a2.5,2.5,0,0,0,2.36.15Z",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.4,465.26a1.5,1.5,0,0,1,.82,1.84,1.45,1.45,0,0,1-1.82.83,1.6,1.6,0,0,1-.86-2,1.52,1.52,0,0,1,2-.65",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.82,479.35a7.63,7.63,0,0,1,1.69-2.31,8,8,0,0,1,2.64-1.12c0-.06-.34-.18-.91-.14a3.94,3.94,0,0,0-2.06.84,3.86,3.86,0,0,0-1.29,1.81C582.72,479,582.76,479.34,582.82,479.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.21,482.18c.13.08.73-.86,1.89-1.48a21.33,21.33,0,0,1,2.26-.81,2.8,2.8,0,0,0-2.52.34C585.52,480.94,585.07,482.14,585.21,482.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.77,475.93a25.43,25.43,0,0,1,2.77-2.48,25,25,0,0,1,3.36-1.59,6.83,6.83,0,0,0-6.13,4.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.77,468.76c.09.13,1.29-.7,3-1.14s3.15-.31,3.17-.47a6.25,6.25,0,0,0-6.17,1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.25,461.76a12,12,0,0,1,3.08-1.27,12.72,12.72,0,0,1,3.34.11c0-.05-.3-.3-.92-.5a5.43,5.43,0,0,0-4.82.87C575.42,461.37,575.2,461.71,575.25,461.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,459.17s0-.34-.16-.91a6.21,6.21,0,0,0-1.22-2.21,2.88,2.88,0,0,0-1.48-1.07,1,1,0,0,0-1.06.45,1.63,1.63,0,0,0-.15,1.16,3.54,3.54,0,0,0,3.72,2.55,4.11,4.11,0,0,0,3.49-2.95A1.46,1.46,0,0,0,581,455a1,1,0,0,0-1.12-.29,3.53,3.53,0,0,0-1.39,1.15,7.21,7.21,0,0,0-1.23,2.21,2.2,2.2,0,0,0-.19.9,11.55,11.55,0,0,1,1.71-2.86,3.2,3.2,0,0,1,1.24-1,.54.54,0,0,1,.61.16,1,1,0,0,1,.07.78,3.66,3.66,0,0,1-3,2.51,3.06,3.06,0,0,1-3.18-2.11,1.18,1.18,0,0,1,.06-.82.56.56,0,0,1,.58-.26,2.58,2.58,0,0,1,1.27.89A9.07,9.07,0,0,1,578,459.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,258c-.25,0-3.29,201.15-3.29,201.15l24.31-.84,8.41-98.9,2-72.6L540,354l20.63,105.39,24.27-6.09L554,256.72l-29.08-5.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.85,133.75c2.91-5.74,3.82-16.06.49-21.77s-10.09-9.84-16.43-11.72a5.53,5.53,0,0,0-3.26-.2,2.18,2.18,0,0,0-1.54,2.55,14.05,14.05,0,0,0-4-2.29,4.73,4.73,0,0,0-4.37.62,2.88,2.88,0,0,0-.42,4.06,5,5,0,0,0-6.74,6.11,16,16,0,0,0,3.23,5.09c1.26,1.34,1.38,2.64,1,4.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.88,181.06c.18-2.76.63-27.7.62-27.81s-9.26-1.15-9.66-10.36c-.19-4.45.16-13.64.57-21.95A17.17,17.17,0,0,1,529,104.62l.89,0c9.6.26,14.74,8.56,14.21,18.15l-1.31,53.37",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.5,153.25a22.28,22.28,0,0,0,11.89-3.92s-2.77,5.76-12,5.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514,127.16a1.33,1.33,0,0,0,1.31,1.29,1.26,1.26,0,0,0,1.32-1.23,1.3,1.3,0,0,0-1.31-1.29A1.26,1.26,0,0,0,514,127.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.53,125.39c.17.16,1.14-.61,2.56-.65s2.47.64,2.62.46-.1-.38-.57-.7a3.62,3.62,0,0,0-2.1-.58,3.48,3.48,0,0,0-2,.73C514.58,125,514.45,125.31,514.53,125.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.14,127.36a1.32,1.32,0,0,0,1.31,1.29,1.25,1.25,0,0,0,1.32-1.23,1.32,1.32,0,0,0-1.31-1.29A1.28,1.28,0,0,0,528.14,127.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.45,125.22c.17.16,1.15-.61,2.56-.65s2.48.64,2.62.46-.1-.38-.56-.7a3.68,3.68,0,0,0-2.11-.58,3.51,3.51,0,0,0-2,.73C528.51,124.83,528.37,125.14,528.45,125.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.64,135.88a8.68,8.68,0,0,0-2.31-.35c-.36,0-.71-.09-.78-.33a1.9,1.9,0,0,1,.21-1.08l1-2.78c1.37-4,2.34-7.23,2.18-7.28s-1.39,3.12-2.76,7.08c-.32,1-.64,1.91-.93,2.8a2.08,2.08,0,0,0-.15,1.43.93.93,0,0,0,.61.51,2.39,2.39,0,0,0,.62.06A9.11,9.11,0,0,0,523.64,135.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.84,136.73c-.23,0-.19,1.53-1.47,2.66s-2.92,1-2.93,1.23.38.28,1.07.28A3.87,3.87,0,0,0,527,140a3.37,3.37,0,0,0,1.13-2.23C528.13,137.09,527.94,136.71,527.84,136.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.91,119.68c.16.38,1.56.15,3.23.3s3,.56,3.23.21c.1-.17-.15-.52-.7-.88a5.48,5.48,0,0,0-2.42-.76,5.41,5.41,0,0,0-2.5.37C528.15,119.19,527.85,119.5,527.91,119.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.92,121.27c.26.32,1.23,0,2.4-.1s2.17.15,2.39-.19c.09-.17-.07-.49-.52-.78a3.37,3.37,0,0,0-2-.47,3.28,3.28,0,0,0-1.89.71C514.93,120.78,514.81,121.12,514.92,121.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.59,129.59c.16-.07,6.27-2.07,6.27,4.24s-6.33,5-6.35,4.82S543.59,129.59,543.59,129.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.44,136.26s.11.08.3.16a1.07,1.07,0,0,0,.82,0,2.72,2.72,0,0,0,1.26-2.44,3.76,3.76,0,0,0-.31-1.57,1.27,1.27,0,0,0-.82-.84.55.55,0,0,0-.65.3c-.09.17,0,.3-.08.31s-.13-.11-.08-.37a.7.7,0,0,1,.24-.39.84.84,0,0,1,.61-.16,1.52,1.52,0,0,1,1.15,1,3.69,3.69,0,0,1,.38,1.75,2.87,2.87,0,0,1-1.61,2.73,1.18,1.18,0,0,1-1-.17C545.45,136.41,545.42,136.27,545.44,136.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.39,109c-.74,8.17,9.33,11.58,13.75,7,2-2.11,3.82-4.75,6.6-5.7a7.5,7.5,0,0,1,5.75.6l0,0c2.6,1.35,4.13,4.36,4.54,7.26.56,4-.09,7.6,1,11.31a2.5,2.5,0,0,0,.78,1.43,2,2,0,0,0,2.49-.63,7.75,7.75,0,0,0,1.58-4.16,25.81,25.81,0,0,0-.38-10.21,17.64,17.64,0,0,0-5.12-8.76,16.74,16.74,0,0,0-11.86-4.06,20.59,20.59,0,0,0-11.77,4.62,12.08,12.08,0,0,0-3.73,4.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.06,104.53a1.88,1.88,0,0,0-.87,0,4.37,4.37,0,0,0-2.08,1.16,5.4,5.4,0,0,0-1.57,3.17,6.1,6.1,0,0,0,1.21,4.16,8,8,0,0,0,3.41,2.66,10.69,10.69,0,0,0,3.44.76,12.74,12.74,0,0,0,2.36-.07,2.85,2.85,0,0,0,.85-.17c0-.09-1.23.08-3.18-.1a11.34,11.34,0,0,1-3.29-.83,7.72,7.72,0,0,1-3.2-2.54A5.71,5.71,0,0,1,511,109a5.12,5.12,0,0,1,1.36-3,4.51,4.51,0,0,1,1.89-1.22C514.76,104.59,515.07,104.58,515.06,104.53Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.28,101.65s-.23-.07-.6.1a2,2,0,0,0-1,1.35,3.62,3.62,0,0,0,.48,2.41,10.43,10.43,0,0,0,1.72,2.41,11,11,0,0,0,4.51,2.86,5.1,5.1,0,0,0,2.18.37c0-.09-.82-.19-2.06-.69a12,12,0,0,1-4.27-2.87,11.14,11.14,0,0,1-1.69-2.29,3.5,3.5,0,0,1-.54-2.14,2,2,0,0,1,.75-1.25C519.07,101.71,519.29,101.69,519.28,101.65Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.39,183.29,421,179.18l-6.86-1.65s-15.68-2.8-17.15-3.27c-1.7-.53-2.37.16-2.52.8-.24,1,.75,2.07,2.19,2.57.5.18,8.49,2.6,8.49,2.6a20.23,20.23,0,0,0-2.63.87c-1.86.71-3.58,3.22-4.37,6.09s-.76,3.74.34,4.1a1.44,1.44,0,0,0,1.24-.22A2.92,2.92,0,0,0,401,189.4c1.34-4.58,4.15-5.05,4.15-5.05l.9.22s-2.84,2.15-2.69,4.61a2.8,2.8,0,0,0,.27,1A3.72,3.72,0,0,0,408,195c.62-.13,1.27-.52,1.34-1.15a2.07,2.07,0,0,0-.24-1,3,3,0,0,1-.17-.5l2.6.25s5.87.26,8.41.66l40.87,10.57a10.46,10.46,0,0,0,12.8-7.69h0A10.47,10.47,0,0,0,464.39,183.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.08,180.32a2.19,2.19,0,0,1-1.79,1.79c-.89.22-1.81.14-2.71.29-2.67.47-4.66,3-7.36,3.34-.37,0-.85,0-1-.37s.15-.66.41-.9l6.49-6.22",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.15,178.25a4.34,4.34,0,0,0-.77.6c-.47.41-1.14,1-2,1.78l-2.88,2.67c-.27.26-.54.52-.83.78s-.67.51-.73,1.13a.75.75,0,0,0,.49.7,1.55,1.55,0,0,0,.73.09,6.38,6.38,0,0,0,1.29-.31,34.55,34.55,0,0,0,4.22-2.36,6.61,6.61,0,0,1,1.9-.71c.62-.12,1.23-.13,1.8-.19a3.16,3.16,0,0,0,2.42-1.16,1.2,1.2,0,0,0,.26-1,2.79,2.79,0,0,1-.42.83,3.06,3.06,0,0,1-2.29.92,18.45,18.45,0,0,0-1.84.13,7.09,7.09,0,0,0-2,.71,39.51,39.51,0,0,1-4.19,2.29,5.47,5.47,0,0,1-1.16.29c-.37,0-.7-.08-.67-.28s.29-.51.57-.77.55-.54.82-.79l2.8-2.76c.79-.79,1.43-1.44,1.86-1.89S414.18,178.28,414.15,178.25Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,184.47a3.72,3.72,0,0,0-1.7.05,2.86,2.86,0,0,0-1.44,1.07,7.29,7.29,0,0,0-1,2.06,12.08,12.08,0,0,1-.9,2.19,3.85,3.85,0,0,1-1.36,1.41,1.47,1.47,0,0,1-1.31.08c-.29-.14-.4-.28-.39-.29s.15.08.43.17a1.38,1.38,0,0,0,1.16-.17,3.63,3.63,0,0,0,1.21-1.36,13.44,13.44,0,0,0,.85-2.14,7.12,7.12,0,0,1,1.05-2.14,3,3,0,0,1,1.62-1.11,2.61,2.61,0,0,1,1.31,0A1,1,0,0,1,406.12,184.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,177.43a9.87,9.87,0,0,1,1.59.47l3.8,1.23,3.82,1.17a10.7,10.7,0,0,1,1.58.53,6.84,6.84,0,0,1-1.64-.3c-1-.24-2.36-.61-3.86-1.08s-2.83-.95-3.78-1.33A7.72,7.72,0,0,1,396.14,177.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.35,186.83s-.11.16-.32.41a1.51,1.51,0,0,0-.44,1.2.81.81,0,0,0,.53.62,4.34,4.34,0,0,0,1.06.25,1.84,1.84,0,0,1,1.18.58,1.6,1.6,0,0,1,.26,1.41,1.82,1.82,0,0,1-.93,1.08,2.21,2.21,0,0,1-1.3.24,6.93,6.93,0,0,1-2-.67,4.17,4.17,0,0,1-1.19-.81,1,1,0,0,1-.29-.45s.13.14.38.36a4.85,4.85,0,0,0,1.19.69,7.65,7.65,0,0,0,2,.58,1.8,1.8,0,0,0,1.87-1.11,1.29,1.29,0,0,0-.19-1.12,1.58,1.58,0,0,0-1-.48,4.75,4.75,0,0,1-1.12-.3,1.06,1.06,0,0,1-.64-.83,2,2,0,0,1,1-1.65Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.49,192.17s.18,0,.43.19a1.42,1.42,0,0,1,.53,1.18,1.91,1.91,0,0,1-1.08,1.57,3.13,3.13,0,0,1-2.34.13,3.83,3.83,0,0,1-1.92-1.35,3.59,3.59,0,0,1-.69-1.77,3.43,3.43,0,0,1,.09-1.28c.08-.29.16-.44.18-.43a5.55,5.55,0,0,0,0,1.67,3.51,3.51,0,0,0,.71,1.63,3.61,3.61,0,0,0,1.77,1.21,2.9,2.9,0,0,0,2.1-.08,1.72,1.72,0,0,0,1-1.32,1.41,1.41,0,0,0-.38-1.07C408.64,192.25,408.48,192.2,408.49,192.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.52,188.34a1.53,1.53,0,0,1,.25-.75,3.16,3.16,0,0,1,1.52-1.35v.29a9.58,9.58,0,0,1-1-.51,7,7,0,0,1-2.81-2.68,17.16,17.16,0,0,0,3,2.4c.33.19.66.36,1,.5l.34.16-.35.13a3.35,3.35,0,0,0-1.47,1.16C415.66,188.08,415.57,188.36,415.52,188.34Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,184.26c.06-.06.54.43.62,1.22s-.27,1.37-.35,1.32.1-.59,0-1.28S401.83,184.32,401.91,184.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.16,204.49,493.44,198S492,249.8,492,250.29s-2.33,1.3-2.13,5.07l2,4.47,62,.83,1.68-50.34,5.66-39-13-8.05L543.63,157l-17.88,18.86-4.45-16.1.13-4.79-4.42,4.8-23.85,6.88-31.51,14.69-21.3-1.63-5.53,18.64Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.28,170.08a2.85,2.85,0,0,0-1.28,1.43,5.67,5.67,0,0,0-.39,2.18,8.44,8.44,0,0,1-.42,3l-.22.51-.22-.51a28.14,28.14,0,0,1-1.4-4.59c-.75-3.24-1.24-6.21-1.56-8.35a21.44,21.44,0,0,1-.37-3.51,27.65,27.65,0,0,1,.74,3.44c.41,2.13,1,5.08,1.7,8.3a31.09,31.09,0,0,0,1.32,4.51h-.43a8.41,8.41,0,0,0,.46-2.79,5.76,5.76,0,0,1,.52-2.28,2.6,2.6,0,0,1,1-1.14A1,1,0,0,1,523.28,170.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.23,162.18a4.29,4.29,0,0,1-.6.87c-.42.53-1,1.3-1.8,2.24-1.54,1.88-3.68,4.45-6.08,7.28L533.93,177l-.3.34-.1-.43c-.55-2.18-1-4-1.28-5.3-.12-.65-.48-1-.83-1a.72.72,0,0,0-.48.13s.07-.26.48-.28a.88.88,0,0,1,.66.27,1.9,1.9,0,0,1,.44.82c.37,1.28.88,3.1,1.46,5.26l-.41-.09,3.78-4.49c2.4-2.82,4.59-5.36,6.2-7.18.8-.91,1.46-1.64,1.92-2.14S546.2,162.15,546.23,162.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.86,245a2.94,2.94,0,0,1-.06-.67c0-.5,0-1.13,0-1.93,0-1.67,0-4.09,0-7.07.06-6,.35-14.23,1-23.33s1.64-17.3,2.46-23.22c.4-3,.77-5.35,1-7l.33-1.9a3.63,3.63,0,0,1,.15-.65,3.38,3.38,0,0,1,0,.67c-.06.49-.14,1.12-.23,1.91-.22,1.72-.52,4.1-.89,7-.72,5.93-1.61,14.13-2.3,23.22s-1,17.33-1.18,23.29c-.07,2.94-.12,5.34-.17,7.08,0,.79,0,1.42-.05,1.92A5,5,0,0,1,519.86,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.81,257.13a11.87,11.87,0,0,1-.47-4.45,16.36,16.36,0,0,1,.52-4.44,23.4,23.4,0,0,1,0,4.45C514.79,255.13,515,257.11,514.81,257.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.21,242.58a12.68,12.68,0,0,1-1.59.6c-1,.36-2.56.83-4.44,1.38A146.38,146.38,0,0,1,519.24,248,143.83,143.83,0,0,1,504,249.92c-1.95.13-3.54.21-4.64.23a10.2,10.2,0,0,1-1.7,0,11.29,11.29,0,0,1,1.69-.18l4.62-.4c3.9-.36,9.28-1,15.16-2s11.15-2.31,14.93-3.31l4.48-1.23A9.78,9.78,0,0,1,540.21,242.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.13,208.89c-.14,0-.23-7.35-.2-16.43s.17-16.43.32-16.42.23,7.35.2,16.43S493.28,208.89,493.13,208.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.06,170.56s7.81,6.7,8.33,10.5c.39,2.93,8.08,30.48,11.54,42.82a17.92,17.92,0,0,1-.66,11.63l-10,24.7-16.15-9.56,8.08-23.16-6.69-19.66Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.29,260.21a1.26,1.26,0,0,1-.3-.15l-.86-.47-3.27-1.87L553,250.83l-.15-.09.06-.15c2.26-6.53,5-14.47,8-23.19v.17c-.94-2.54-1.93-5.19-2.94-7.9-2.37-6.37-4.62-12.45-6.68-18h0c-2.05-4.29-3.82-8.44-4.31-12.42a17.54,17.54,0,0,1,.16-5.59,16.82,16.82,0,0,1,1.62-4.49,18.69,18.69,0,0,1,4.18-5.26,16.75,16.75,0,0,1,1.4-1.12,3.11,3.11,0,0,1,.52-.33,3.09,3.09,0,0,1-.47.4c-.32.25-.78.63-1.35,1.16a19.3,19.3,0,0,0-4,5.29,16.07,16.07,0,0,0-1.54,4.42,17.14,17.14,0,0,0-.11,5.47c.51,3.89,2.28,8,4.35,12.27h0l6.72,18c1,2.71,2,5.36,2.94,7.91l0,.08,0,.09c-3.06,8.7-5.84,16.63-8.13,23.15l-.09-.24,11.73,7,3.22,2,.83.52C569.2,260.13,569.3,260.2,569.29,260.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.66,174.18a2.41,2.41,0,0,1,2.4,1.76c.2,1.08.05,2.2.33,3.26s1.25,2.1,2.32,1.87a2.85,2.85,0,0,0,1.53-1.2,37.16,37.16,0,0,0,5-9.29c0,.07-5.54,6.36-5.54,6.36a18.65,18.65,0,0,0-1.24-4.63c-.19-.48-.4-1.29-.86-1.51-.75-.34-1.75.76-2.25,1.42a12.43,12.43,0,0,1-1.73,1.86"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.63,168.48a32.16,32.16,0,0,0,2,10.28,2.24,2.24,0,0,0,.54.9.84.84,0,0,0,1,.14,12.21,12.21,0,0,0,1-2.13c.51-1.43,2.59-1.56,2.59-1.56a37.64,37.64,0,0,0-1.36-4.76,1.33,1.33,0,0,0-1.29-.83,2.15,2.15,0,0,0-1.42,1.63c-.31,2.57-.27,3.74-.65,4.64-1-2.73-1.76-6-2.4-8.41"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M534,244.23a2.18,2.18,0,0,0,.48-3.08,3.35,3.35,0,0,0-3.13-1.19,7,7,0,0,0-3.16,1.42c-.95.69-1.82,1.48-2.82,2.09-2.45,1.5-5.43,1.85-8.31,1.89a49.44,49.44,0,0,0-8.61.39c-2.82.54-5.64,2-7,4.53C501.41,250.28,526,248.5,534,244.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M550,280.35a20.39,20.39,0,0,1-6.44-6.64.28.28,0,0,0,0-.22.4.4,0,0,0-.25-.15,32,32,0,0,1-1.88-3.3c2-1.3,4.63-3.28,1.78-3.68-3.51-.5-6-2.21-6.38-3.14a1.11,1.11,0,0,1,1.73-1.18,13.22,13.22,0,0,0,3.38,1.17,8.66,8.66,0,0,0,2.87.18c.59-.07,2.68-1.5,4.92-2.55a1.71,1.71,0,0,1,1-.14l.85-.06a2.62,2.62,0,0,0,2.17-1.42l3.25-6.24,9.8,5.8-7.76,10.76A129.6,129.6,0,0,1,550,280.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.06,281.47a7.7,7.7,0,0,1-2.26-1.06,20.36,20.36,0,0,1-4.64-3.86,20.58,20.58,0,0,1-3.32-5,8.26,8.26,0,0,1-.81-2.37,26.23,26.23,0,0,0,11,12.33Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.19,287.78s-.1,0-.28-.08a3.38,3.38,0,0,1-.69-.45,5.72,5.72,0,0,1-1.6-2.54,40.67,40.67,0,0,1-1.09-4.28c-.36-1.62-.73-3.4-1.1-5.28-.74-3.75-1.3-7.17-1.66-9.65-.18-1.24-.31-2.25-.38-2.94a4.71,4.71,0,0,1-.07-1.09,4,4,0,0,1,.27,1l.54,2.92c.46,2.46,1.07,5.86,1.81,9.61.37,1.87.73,3.64,1.06,5.28s.59,3.09,1,4.26a6.14,6.14,0,0,0,1.38,2.51C520.85,287.58,521.21,287.74,521.19,287.78Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.35,265.33s.17-.06.44,0a1.7,1.7,0,0,1,.92.81,1.72,1.72,0,0,1-.1,1.83,2,2,0,0,1-2.1.8,2.11,2.11,0,0,1-1.47-1.7,2,2,0,0,1,.63-1.72c.83-.71,1.58-.5,1.54-.46a3.17,3.17,0,0,0-1.28.72,1.59,1.59,0,0,0-.41,1.38,1.64,1.64,0,0,0,1.13,1.27,1.58,1.58,0,0,0,1.58-.57,1.39,1.39,0,0,0,.15-1.39C521,265.49,520.31,265.4,520.35,265.33Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.09,261.31a5.85,5.85,0,0,1,.26,2.3,12.37,12.37,0,0,1-5.17,9.61,5.78,5.78,0,0,1-2.07,1c0-.08.75-.47,1.85-1.34a13.57,13.57,0,0,0,5-9.34C499.11,262.2,499,261.32,499.09,261.31Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.28,191.15a34.32,34.32,0,0,1,.51-5,35,35,0,0,1,.72-4.94,18.57,18.57,0,0,1-.21,5A19,19,0,0,1,460.28,191.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.35,179.73a1.36,1.36,0,0,1-.07.35c-.06.27-.15.6-.26,1-.26.92-.61,2.2-1.06,3.8L435,198.43l-.16-.28c5.65,1.4,12.46,2.54,19.73,3.88,3.62.68,7.11,1.41,10.33,2.21h-.11l20.28-4.59,5.91-1.28,1.58-.33a2.09,2.09,0,0,1,.56-.08,3.65,3.65,0,0,1-.54.17l-1.56.4L485.18,200l-20.24,4.77h-.12c-3.21-.79-6.69-1.51-10.31-2.18-7.25-1.34-14.08-2.51-19.74-4l-.23-.05.07-.23c1.68-5.55,3.09-10.18,4.1-13.49.49-1.58.89-2.84,1.18-3.76q.19-.6.33-1A2.07,2.07,0,0,1,440.35,179.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.62 410.73 157.73 464.24 177.12 468.92 180.98 416.65 160.62 410.73",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.16 463.79 153.86 478.31 176.16 478.31 177.12 468.85 157.16 463.79",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,476.2a16.29,16.29,0,0,1-3.25.18c-2,0-4.78,0-7.84-.14l-7.83-.33a19.86,19.86,0,0,1-3.24-.26,15.4,15.4,0,0,1,3.25-.18c2,0,4.78,0,7.84.15l7.83.33A18.08,18.08,0,0,1,176.62,476.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,466.62c.17,0,.16,2.11,0,4.7s-.45,4.67-.62,4.66-.17-2.12,0-4.7S167,466.6,167.17,466.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "153.86 478.31 176.16 478.31 176.38 476.2 154.26 475.65 153.86 478.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "234.22 436.75 238.93 472.2 256.08 471.01 252.48 438.5 234.22 436.75",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,467.16h0s19.28,6.51,19.6,10L239,478.26l-.33-9.63,1.36.27A27.39,27.39,0,0,0,256.26,467.16Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243,470.31a1.5,1.5,0,0,0-1,1.75,1.44,1.44,0,0,0,1.72,1,1.58,1.58,0,0,0,1-1.85,1.5,1.5,0,0,0-1.91-.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,478.26v-3l35.34.09s1.66.67,1.51,1.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.85,467c0,.18-.89.28-1.76.89s-1.32,1.37-1.49,1.31.07-1.12,1.14-1.83S256.89,466.79,256.85,467Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,468.44c0,.17-.73.5-1.32,1.28s-.74,1.59-.92,1.59-.32-1,.43-2S260.76,468.27,260.77,468.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,473c-.16,0-.44-.85,0-1.85s1.27-1.42,1.35-1.27-.43.69-.77,1.51S263.28,473,263.1,473Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,466.86a3.37,3.37,0,0,1-1.85.05,8.19,8.19,0,0,1-1.94-.54,7.69,7.69,0,0,1-1.08-.53,2.43,2.43,0,0,1-.57-.42.77.77,0,0,1-.11-.95,1,1,0,0,1,.78-.44,2.08,2.08,0,0,1,.69.08,6,6,0,0,1,1.16.36,6.66,6.66,0,0,1,1.73,1.06c.88.77,1.19,1.44,1.13,1.47s-.51-.49-1.4-1.12a7.63,7.63,0,0,0-1.67-.88,6.69,6.69,0,0,0-1.07-.29c-.39-.09-.73-.09-.82.09s0,.09,0,.21a1.61,1.61,0,0,0,.41.3,10.81,10.81,0,0,0,1,.53,10,10,0,0,0,1.8.63A15.5,15.5,0,0,1,256.45,466.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,467.13a3,3,0,0,1-.53-1.77,6,6,0,0,1,.19-2,5.27,5.27,0,0,1,.44-1.13,1.51,1.51,0,0,1,1.15-1,.86.86,0,0,1,.78.49,2.55,2.55,0,0,1,.21.67,4.06,4.06,0,0,1,0,1.25,4.33,4.33,0,0,1-.73,1.93c-.7,1-1.44,1.21-1.46,1.15s.56-.46,1.08-1.39a4.2,4.2,0,0,0,.53-1.75,3.9,3.9,0,0,0-.06-1.07c-.07-.39-.23-.7-.37-.65s-.49.3-.63.62a6.65,6.65,0,0,0-.43,1,6.76,6.76,0,0,0-.3,1.86C256.11,466.43,256.32,467.1,256.22,467.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,257.26S161.35,280,161.35,293.59L158,459.19l21.5,5.13,16.4-161.84s39.72,162.26,41,162.26,20.83-3.51,20.83-3.51L228.07,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,298a1.88,1.88,0,0,1,0,.42c0,.3-.1.71-.17,1.22-.18,1.1-.43,2.67-.75,4.67-.66,4.05-1.58,9.91-2.68,17.17-2.18,14.48-4.91,34.58-7.2,56.89s-3.68,42.52-4.47,57.18c-.4,7.33-.69,13.26-.86,17.36-.09,2-.17,3.61-.22,4.72,0,.52-.06.92-.07,1.23a2.1,2.1,0,0,1-.05.42,2.76,2.76,0,0,1,0-.42c0-.31,0-.72,0-1.23,0-1.12.06-2.7.11-4.73.1-4.1.32-10,.67-17.37.69-14.67,2-34.92,4.3-57.22s5.08-42.39,7.38-56.89c1.15-7.25,2.13-13.11,2.87-17.15.36-2,.65-3.56.85-4.65.1-.51.17-.91.23-1.21A2.94,2.94,0,0,1,183.42,298Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,300.77c.16,0,6.72,36.32,14.65,81.17s14.23,81.25,14.07,81.28-6.72-36.31-14.65-81.18S217.29,300.8,217.45,300.77Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,302.2s-.1-.13-.23-.41-.32-.69-.55-1.23a42.77,42.77,0,0,1-1.59-4.67,47.41,47.41,0,0,1-1.54-16.16c.11-1.6.33-3.14.57-4.62s.65-2.89,1-4.22c.75-2.65,1.54-5,2.22-7s1.26-3.55,1.68-4.63l.5-1.25a2.63,2.63,0,0,1,.2-.42,1.4,1.4,0,0,1-.11.46l-.4,1.28c-.39,1.18-.9,2.76-1.52,4.67s-1.38,4.34-2.11,7c-.36,1.32-.73,2.72-1,4.17s-.44,3-.55,4.57a50.3,50.3,0,0,0,1.37,16c.51,2,1.06,3.59,1.43,4.69A15.47,15.47,0,0,1,195.14,302.2Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,274.39l0,.31c0,.24,0,.53.05.88,0,.81.08,1.91.14,3.27.1,2.84.24,6.79.4,11.52l-.14-.2,8.28,3.37-.23,0,6.72-4.09.44-.27-.13.2c.51-5.46,1-10.6,1.4-15l.22.25L206,274.5l-3.53-.06-.94,0-.34,0a8.43,8.43,0,0,1,1.19-.06l3.47-.06,12.52-.11h.25l0,.25c-.39,4.43-.84,9.57-1.33,15v.13l-.11.07-.44.26L210,294l-.11.07-.11-.05-8.26-3.43-.13-.05v-.15c-.07-4.79-.13-8.79-.17-11.67,0-1.34,0-2.42,0-3.22A7.27,7.27,0,0,1,201.23,274.39Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.11,270s0,.41-.15,1.12-.27,1.77-.46,3c-.43,2.63-1,6.28-1.72,10.65l-.09-.22,6.25,4.63-.22,0,7.6-2.11.39-.11-.18.18c1.45-5,2.82-9.61,4-13.63l.17.29-11.23-2.68-3.2-.79c-.74-.19-1.15-.3-1.16-.32a9.39,9.39,0,0,1,1.09.2l3.17.66,11.43,2.48.23.06-.06.23L182,287.28l0,.14-.14,0-.39.11-7.6,2.1-.12,0-.1-.07L167.42,285l-.11-.09,0-.13c.81-4.41,1.48-8.1,2-10.75.24-1.23.43-2.22.57-3A6.87,6.87,0,0,1,170.11,270Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53,299a84.7,84.7,0,0,1-9.14,2.25,86.34,86.34,0,0,1-9.26,1.74,84.53,84.53,0,0,1,9.15-2.25A85.94,85.94,0,0,1,213.53,299Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,299.71a8.81,8.81,0,0,1-2.34,0,38.39,38.39,0,0,1-5.6-.87,37.47,37.47,0,0,1-5.41-1.66,8.16,8.16,0,0,1-2.11-1,14.38,14.38,0,0,1,2.23.68c1.37.44,3.27,1,5.41,1.49s4.09.82,5.52,1A13.15,13.15,0,0,1,186.8,299.71Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,127.19c.74,2.14-1.8,4-4,4.47s-4.88.82-5.89,2.85c-.88,1.76,0,4-.79,5.79-1.52,3.41-7.66,2.7-8.86,6.24C164,149,166.32,151.47,166,154c-.25,2.19-2.26,3.69-4,5s-3.62,3.16-3.35,5.36c.32,2.53,3.42,4.28,3.13,6.82s-3.64,3.66-4.13,6.13c-.57,2.92,3.09,4.8,4.27,7.54.9,2.09.34,4.79,1.86,6.49s4.32,1.39,6.6.91l22.77-4.83c-1.54-3.59-.1-7.81,2.1-11.05s5.11-6,7-9.4,2.5-8,0-11.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,145.39a24.07,24.07,0,0,0-.75-3.6,3.53,3.53,0,0,0-.91-1.47c-.45-.43-1-.16-1.4.45a11,11,0,0,0,0,9.23c.37.62,1,.89,1.4.46a3.63,3.63,0,0,0,.91-1.48,24.11,24.11,0,0,0,.75-3.59,2.84,2.84,0,0,1,.08,1,10,10,0,0,1-.43,2.73,4,4,0,0,1-1,1.72,1.21,1.21,0,0,1-1.21.28,2,2,0,0,1-1-.81,11.19,11.19,0,0,1,0-9.84,2,2,0,0,1,1-.81,1.21,1.21,0,0,1,1.21.28,4,4,0,0,1,1,1.72,10,10,0,0,1,.43,2.72A2.92,2.92,0,0,1,224.45,145.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,166.35c-4.12-7-5.3-16.23-6.34-24.24-.49-3.78-1.35-9.15,1.3-11.51,2.85-2.53,3.12-6.43,6.39-8.38s7.7-2.11,10.78.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72,191h0a11.15,11.15,0,0,0,12-10.67c.26-6.08.48-12.22.48-12.22s9.21-.84,9.91-10,.45-30.16.45-30.16h0a31.77,31.77,0,0,0-32.11,2l.47,32.08-.05,17.26C190,185.1,193,190.54,198.72,191Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.09,147c-1.56-1.95-4.12-2.73-6.22-1.37a5.3,5.3,0,0,0-1.79,6.62,7,7,0,0,0,4.47,3.39,3.51,3.51,0,0,1,2.73,3.78c-.27,2.28-4.08,3.13-5.81,5-2.68,2.94-8.54,4.17-12.49,4.62s-3.42.49-5.67-2.71a12.26,12.26,0,0,1-2.2-7.4q-.17-10.09-.35-20.17a28.23,28.23,0,0,1,.48-7.23,9.66,9.66,0,0,1,3.83-6c2.22-1.46,5-1.57,7.56-2.38,3.16-1,5.85-3.1,8.8-4.6s6.59-2.4,9.55-.9c2.12,1.08,3.54,3.2,5.61,4.39,2.94,1.68,7,1.31,8.37,5.65a7.37,7.37,0,0,1-.06,4.64c-2,5.89-9.33,8.24-14.58,5.68-.1,1,.87,3.22-.19,6.38-.34,1-.46,2.54-2,2.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.44,152.69s0,.17-.12.39a1.36,1.36,0,0,1-1,.51,2.5,2.5,0,0,1-2.35-2.52,2.62,2.62,0,0,1,.67-1.93,2.72,2.72,0,0,1,1.43-.82c.94-.19,1.48.16,1.44.21s-.56,0-1.31.23A2.28,2.28,0,0,0,207.6,151a2.13,2.13,0,0,0,1.7,2.09C210.07,153.18,210.38,152.63,210.44,152.69Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,145a33.25,33.25,0,0,1-6.13,1.31,34.5,34.5,0,0,1-6.23.72c0-.17,2.72-.75,6.13-1.31A33.53,33.53,0,0,1,224.47,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,175.25a2.65,2.65,0,0,0,3.17,1.27,7.63,7.63,0,0,0,3.06-2.08,8.06,8.06,0,0,1,3-2.12c2.43-.74,5.41.88,7.45-.63,1.86-1.37,1.62-4.48,3.45-5.9,1-.75,2.32-.85,3.31-1.58,1.85-1.36,1.54-4.41,0-6.11s-3.89-2.38-6.1-3l-19.59,8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,139.85s-.05.05-.16.12a4.05,4.05,0,0,1-.52.29,10.55,10.55,0,0,1-2.14.77,24.39,24.39,0,0,1-3.56.57,36.09,36.09,0,0,0-4.68.64,8.81,8.81,0,0,0-4.83,2.65c-1.32,1.53-1.82,3.73-2.84,5.87a7.57,7.57,0,0,1-2.28,2.87,12,12,0,0,1-3.41,1.68c-2.41.8-5.06,1.29-7.06,3a5,5,0,0,0-1.81,3.2,22,22,0,0,0,0,3.81,7,7,0,0,1-.73,3.75,6.89,6.89,0,0,1-2.65,2.55c-2,1.21-4.19,1.85-5.9,2.94a6.84,6.84,0,0,0-2.11,1.95,5.12,5.12,0,0,0-.8,2.49,17.16,17.16,0,0,0,.63,4.63,12,12,0,0,1,.33,3.6,5,5,0,0,1-.65,2.19,2.73,2.73,0,0,1-.5.63,5.43,5.43,0,0,0,.92-2.83,12.14,12.14,0,0,0-.42-3.51,17.15,17.15,0,0,1-.73-4.73,5.53,5.53,0,0,1,.83-2.72,7.27,7.27,0,0,1,2.23-2.11c1.78-1.16,3.94-1.82,5.89-3a5.72,5.72,0,0,0,3.08-5.83,22.19,22.19,0,0,1,0-3.91,5.62,5.62,0,0,1,2-3.56c2.18-1.83,4.92-2.3,7.26-3.09a11.61,11.61,0,0,0,3.26-1.58,7.08,7.08,0,0,0,2.13-2.67c1-2,1.52-4.3,2.95-5.94a9.12,9.12,0,0,1,5.12-2.73,33.67,33.67,0,0,1,4.74-.57,27.3,27.3,0,0,0,3.54-.46A15.3,15.3,0,0,0,211.31,139.85Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,143.12c0,.06-.71,0-1.91.27a8.65,8.65,0,0,0-4.39,2.62,8,8,0,0,0-1.75,3.07,13.37,13.37,0,0,0-.36,4.09,10.67,10.67,0,0,1-.68,4.68,4.72,4.72,0,0,1-1.71,1.92A21.43,21.43,0,0,1,193,161a5.93,5.93,0,0,0-1.94,1.38,3.51,3.51,0,0,0-.77,2.1c-.11,1.52.22,3.21-.52,4.67a7.68,7.68,0,0,1-3.05,3c-1.15.68-2.27,1.19-3.21,1.76a7.7,7.7,0,0,0-2.26,1.87,5.06,5.06,0,0,0-1,2,4.47,4.47,0,0,0,0,1.89,1.11,1.11,0,0,1-.2-.47,3.46,3.46,0,0,1-.06-1.46,5.17,5.17,0,0,1,.93-2.13,8.14,8.14,0,0,1,2.31-2c1-.61,2.07-1.14,3.17-1.82a7.18,7.18,0,0,0,2.81-2.84c.65-1.26.35-2.82.44-4.47a4.09,4.09,0,0,1,.89-2.44,6.43,6.43,0,0,1,2.14-1.53c1.53-.75,3.08-1.43,3.71-2.86a10.28,10.28,0,0,0,.65-4.42,14,14,0,0,1,.44-4.24,8.14,8.14,0,0,1,1.91-3.2,8.63,8.63,0,0,1,4.65-2.57,6.29,6.29,0,0,1,1.45-.1A1.69,1.69,0,0,1,206,143.12Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "213.47 176.62 211.1 171.75 190.51 170.97 187.28 177.3 213.14 177.3",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.25,220.67c-.15-.74,5.44-29.82,7-37.8a1.69,1.69,0,0,0-1.66-2H248.35a1.68,1.68,0,0,0-1.65,1.3l-8.44,35.59-20.81,1.55.73,1.37Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.44 218.09 289.11 182.84 248.58 183.08 239.68 218.14 282.44 218.09",
    style: {
      fill: "#334155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.65,218.16v0l8.9-35.07h0l40.56-.25v0l-6.68,35.27h0Zm8.95-35-8.89,35,42.71-.05,6.66-35.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,218.33c0,.14-11.86.26-26.48.26s-26.49-.12-26.49-.26,11.85-.26,26.49-.26S282.4,218.19,282.4,218.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,209.43a1.65,1.65,0,0,1-.52,0l-1.52.05-5.59.08c-4.72,0-11.23.08-18.43.08H247.3l.08-.31c1.44-5.55,2.69-10.4,3.61-14,.45-1.68.82-3,1.1-4.08a10.14,10.14,0,0,1,.46-1.45,9.42,9.42,0,0,1-.29,1.5c-.24,1-.56,2.41-1,4.11-.87,3.56-2.06,8.42-3.43,14l-.24-.31h5.91c7.2,0,13.71,0,18.43.08l5.59.08,1.52,0A1.65,1.65,0,0,1,279.6,209.43Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.25 208.09 251 204.69 256.22 204.69 255.55 208.09 250.25 208.09",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.34 208.09 258.91 201.4 264.13 201.4 262.65 208.09 257.34 208.09",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.43 208.09 265.19 204.69 270.41 204.69 269.74 208.09 264.43 208.09",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.52 208.09 274.51 195.09 279.73 195.09 276.83 208.09 271.52 208.09",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.34,211.89a4.46,4.46,0,0,1-2.11.24c-1.16,0-2.1-.13-2.1-.28a8.65,8.65,0,0,1,4.21,0Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.21,211.88a4.55,4.55,0,0,1-2.1.24,4.62,4.62,0,0,1-2.11-.28,4.54,4.54,0,0,1,2.11-.24A4.45,4.45,0,0,1,261.21,211.88Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.09,211.87a4.61,4.61,0,0,1-2.11.24,4.56,4.56,0,0,1-2.1-.28,4.51,4.51,0,0,1,2.11-.24A4.45,4.45,0,0,1,268.09,211.87Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,211.86a8.69,8.69,0,0,1-4.22,0,8.69,8.69,0,0,1,4.22,0Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,188.36a33.32,33.32,0,0,1-5.83.26,33.39,33.39,0,0,1-5.84-.26,33.39,33.39,0,0,1,5.84-.26A33.32,33.32,0,0,1,264.85,188.36Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,186.91a12.56,12.56,0,0,1-5.18,0,13,13,0,0,1,5.18,0Z",
    style: {
      fill: "#818cf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.54,242.1l23.86-17.27-.89-1.44a11.51,11.51,0,0,0-5.58-4.68l-3.73.67-22.12,3.37Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.71 238.13 182.54 230.25 178.11 213.84 161.96 219.33 162.71 238.13",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,242.56c4.94-2.45,6.21-8.34,3.8-13.3L230,185.36a8,8,0,0,0-2.07-2.83,23.19,23.19,0,0,0-17-5.82l-21.42-.56s-16.83,0-23.14,13.26c-.46,1-10.24,20.37-16.69,33.15a11.05,11.05,0,0,0,6.06,15.36h0a11,11,0,0,0,13.9-5.85l7-15.62L181,238.82l-6.35,18.44,53.11.73-4.08-24.67-1.29-17.58L233.2,238a10,10,0,0,0,13.51,4.61Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.83,238.39c4,3,9.95,2,14.9,1.19a21.53,21.53,0,0,0,13-7,8.76,8.76,0,0,0,2.41-6.13c-.2-2.25-2.19-4.42-4.43-4.15-2.56.31-3.8,3.19-5,5.46a19.89,19.89,0,0,1-20.73,9.73S182.12,237.86,182.83,238.39Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.63,203.83c1.25,10.1.69,9.34,2.8,19.3,1,4.89,2.29,10,5.67,13.7l-1.67-21.09Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "174.69 257.26 173.17 252.83 177.13 250.19 225.85 246.17 229.28 252.63 227.8 257.99 174.69 257.26",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,173.67a7.26,7.26,0,0,0-3.38,10.84,3.64,3.64,0,0,1,.93,2c-.1,1.8-3,1.85-3.92,3.4a2.77,2.77,0,0,0,.78,3.25,21.05,21.05,0,0,0,3,2,3.68,3.68,0,0,1,1.84,2.93c1,0,1.62-1.26,1.47-2.26a10.13,10.13,0,0,0-1.25-2.77,2.89,2.89,0,0,1-.13-2.89c.66-.95,2-1,3.1-1.41a4.32,4.32,0,0,0,2.29-5.56c-.66-1.46-2.18-2.94-1.44-4.36.41-.79,1.36-1.09,2.14-1.53a5.57,5.57,0,0,0,.73-9.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,218.59a13,13,0,0,1-1.08,2.49c-.74,1.51-1.82,3.56-3.12,5.77s-2.59,4.13-3.56,5.51a13.27,13.27,0,0,1-1.66,2.14,14.8,14.8,0,0,1,1.36-2.35c.88-1.42,2.11-3.38,3.41-5.57s2.42-4.21,3.24-5.67A14.62,14.62,0,0,1,176.5,218.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.83,227a8.54,8.54,0,0,1-2.2,6.86c-.13-.09.77-1.46,1.36-3.35S171.67,227,171.83,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,227.68c-.13.06-4.29-8.64-9.28-19.42s-8.94-19.58-8.81-19.64,4.29,8.63,9.28,19.42S249.77,227.62,249.64,227.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.34,182.84c0,.08-.9.41-2.22,1.23a13.86,13.86,0,0,0-6.44,9.81c-.23,1.54-.16,2.52-.25,2.53a6.46,6.46,0,0,1-.12-2.58,12.91,12.91,0,0,1,6.62-10.08A6.37,6.37,0,0,1,224.34,182.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,239c-.14,0-2.53-10.14-5.34-22.73s-5-22.81-4.83-22.84,2.53,10.14,5.34,22.73S181.12,239,181,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "271.4 224.83 281.08 220.66 268.18 220.66 271 224.32",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.5,225.91a16.74,16.74,0,0,1-2.35-2.21,17.89,17.89,0,0,1-2.28-2.28,7.15,7.15,0,0,1,2.64,1.91A7.42,7.42,0,0,1,251.5,225.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,238.77a8.37,8.37,0,0,1-.82-1.35c-.5-.88-1.19-2.17-2-3.77-1.68-3.21-3.92-7.68-6.36-12.62s-4.69-9.41-6.36-12.62c-.79-1.54-1.46-2.82-2-3.8a9.94,9.94,0,0,1-.67-1.42,9,9,0,0,1,.85,1.32c.52.87,1.25,2.14,2.12,3.73,1.75,3.17,4.05,7.61,6.49,12.56s4.6,9.35,6.23,12.68l1.88,3.85A9.41,9.41,0,0,1,233.65,238.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,225.18s0,.13,0,.35a8.94,8.94,0,0,1-.17,1A13.21,13.21,0,0,1,213,230a19.49,19.49,0,0,1-9,8,39,39,0,0,1-11.71,2.92c-1.53.17-2.78.27-3.64.33a5.72,5.72,0,0,1-1.34,0,8.09,8.09,0,0,1,1.32-.23l3.61-.5a42.2,42.2,0,0,0,11.54-3,20,20,0,0,0,8.87-7.66A18.89,18.89,0,0,0,214.5,225.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,251c0,.14-6.58.72-14.72,1.29s-14.74.92-14.75.77,6.58-.72,14.72-1.29S203.81,250.8,203.82,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.31,247a23.91,23.91,0,0,1,1.06,10.08c-.15,0-.21-2.27-.51-5S212.17,247,212.31,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.73,243.82a6.82,6.82,0,0,1,.44,2,25.41,25.41,0,0,1-.69,9.87,6.42,6.42,0,0,1-.72,1.93c-.16,0,.78-3,1-6.87S215.57,243.84,215.73,243.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53,177a104.89,104.89,0,0,1-10.63-.33c-5.86-.33-10.6-.72-10.6-.86s4.77,0,10.63.34S213.53,176.83,213.53,177Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-103"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "678.63 195.1 674.4 187.88 670.38 195.1 613.37 195.1 613.37 224.91 702.15 224.91 702.15 195.1 678.63 195.1",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33,210.26a4.36,4.36,0,0,0,2.64-4,4.11,4.11,0,1,0-8.2-.11,4.38,4.38,0,0,0,2.58,4.11c-6.32.9-6.09,7.76-6.09,7.76l14.92.19S635.58,211.26,629.33,210.26Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,203.93c0,.09-11.34.16-25.31.16s-25.31-.07-25.31-.16,11.33-.15,25.31-.15S692,203.85,692,203.93Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,208.48c0,.08-11.34.15-25.31.15s-25.31-.07-25.31-.15,11.33-.15,25.31-.15S692,208.4,692,208.48Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,213c0,.09-11.34.16-25.31.16s-25.31-.07-25.31-.16,11.33-.15,25.31-.15S692,212.94,692,213Z",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.71,217.52c0,.09-5.67.16-12.65.16s-12.66-.07-12.66-.16,5.67-.15,12.66-.15S666.71,217.44,666.71,217.52Z",
    style: {
      fill: "#1e293b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.42,348.86a4.8,4.8,0,0,1-.85.06l-2.44.05-8.95.09-29.54.08h-2.38v-.28c0-11,.06-20.92.09-28.13,0-3.53.06-6.4.08-8.45,0-.95,0-1.72.05-2.29a4.23,4.23,0,0,1,.06-.8,5.06,5.06,0,0,1,0,.8c0,.57,0,1.34.05,2.29,0,2.05.05,4.92.09,8.45,0,7.21,0,17.1.09,28.13l-.28-.28h2.1l29.54.09,8.95.08,2.44.06A5.74,5.74,0,0,1,310.42,348.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.54,318.82a11.72,11.72,0,0,1-1.31,1.25l-3.7,3.25c-3.15,2.73-7.51,6.47-12.36,10.57l-.74.62-.18.16-.18-.17-5.5-5.11h.34l-8.07,6.66-2.34,1.87a5.25,5.25,0,0,1-.88.63,5.07,5.07,0,0,1,.77-.76l2.25-2,7.94-6.81.17-.15.17.15,5.52,5.08h-.36l.73-.62c4.85-4.1,9.25-7.79,12.46-10.44l3.82-3.12A12,12,0,0,1,305.54,318.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.54,328a14.41,14.41,0,0,1-.19-2.74c-.05-1.69-.08-4-.09-6.67l.28.28h-.47c-2.73,0-5.2,0-7-.08a14.55,14.55,0,0,1-2.9-.2,16.23,16.23,0,0,1,2.9-.19c1.79-.06,4.26-.09,7-.09h.75v.28c0,2.62,0,5-.09,6.67A14.41,14.41,0,0,1,305.54,328Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.8,194.81a15.84,15.84,0,0,1,4,1.07l3-2.49,5.1,3.88-1.6,3.53a15.43,15.43,0,0,1,2.1,3.61l3.86.34.86,6.36-3.63,1.35a15.61,15.61,0,0,1-1.06,4l2.49,3-3.89,5.1L128.52,223a16.1,16.1,0,0,1-3.62,2.11l-.34,3.86-6.35.86-1.36-3.63a15.84,15.84,0,0,1-4-1.07l-3,2.49-5.1-3.88,1.6-3.53a15.43,15.43,0,0,1-2.1-3.61l-3.86-.34-.86-6.36,3.63-1.35a15.79,15.79,0,0,1,1.06-4.05l-2.49-3,3.89-5.1,3.52,1.61a16.1,16.1,0,0,1,3.62-2.11l.34-3.86,6.35-.86,1.36,3.63Zm-2.61,8.82a6.88,6.88,0,1,0,7.74,5.9A6.88,6.88,0,0,0,118.19,203.63Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.19,203.63a1.24,1.24,0,0,1,.43-.09,5.49,5.49,0,0,1,1.27,0,6.89,6.89,0,0,1,4.22,1.94,7.09,7.09,0,0,1,0,10.14,7.11,7.11,0,0,1-8.38,1.14A7.09,7.09,0,0,1,113,207a6.91,6.91,0,0,1,3.55-3,5.37,5.37,0,0,1,1.24-.31,1.23,1.23,0,0,1,.44,0c0,.06-.6.12-1.6.54a6.91,6.91,0,0,0-3.28,3,6.64,6.64,0,0,0,10.39,8,6.57,6.57,0,0,0,1.88-3.35,6.69,6.69,0,0,0-1.75-6.12,6.84,6.84,0,0,0-4-2C118.8,203.59,118.19,203.69,118.19,203.63Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,194.81s0-.07-.1-.22l-.28-.67c-.25-.65-.61-1.55-1.06-2.71l.09.06-6.34.91.12-.12c-.1,1.17-.21,2.47-.32,3.86V196l-.09,0a15.82,15.82,0,0,0-3.56,2.1l-.09.07-.1-.05-3.53-1.59.23-.06-3.86,5.12v-.28l2.5,3,.09.1,0,.13a15.78,15.78,0,0,0-1.05,4v.14l-.14.05-3.63,1.37.16-.27c.28,2,.57,4.15.87,6.35l-.23-.22,3.86.34h.16l.06.15a15.54,15.54,0,0,0,2.08,3.54l.1.13-.07.15c-.5,1.11-1,2.31-1.61,3.53l-.08-.33,5.11,3.88h-.35l3-2.49.13-.11.16.07a15.57,15.57,0,0,0,4,1h0c.1.08-.23-.17.22.18h0v0l0,.05,0,.12.08.23.17.45.34.91c.23.61.45,1.21.68,1.81l-.3-.18,6.36-.86-.24.25c.12-1.3.23-2.58.34-3.86l0-.16.15-.07a15.46,15.46,0,0,0,3.55-2.06l.13-.1.15.07,3.52,1.61-.32.08,3.89-5.1v.32l-2.48-3-.1-.11.06-.14a15.44,15.44,0,0,0,1.06-4v-.14l.14,0,3.63-1.35-.15.25c-.29-2.24-.57-4.35-.84-6.36l.19.18-3.85-.35h-.13l0-.11a15.14,15.14,0,0,0-2.07-3.58l-.07-.09,0-.1,1.62-3.52.05.2-5.07-3.91h.15l-3,2.47,0,0,0,0a16.34,16.34,0,0,0-3-.94l-.76-.15c-.18,0-.26-.05-.25-.06h.26c.17,0,.43.05.77.11a15.18,15.18,0,0,1,3,.86l-.09,0,3-2.52.08-.06.08.06,5.12,3.85.11.08-.06.12-1.59,3.53,0-.18a15.9,15.9,0,0,1,2.15,3.64l-.17-.12,3.86.33h.17l0,.17c.28,2,.57,4.12.88,6.35l0,.19-.18.06-3.62,1.37.15-.2a16,16,0,0,1-1.07,4.11l0-.26c.81,1,1.65,2,2.49,3l.13.16-.12.16-3.88,5.11-.12.17-.2-.09-3.53-1.6.28,0a16,16,0,0,1-3.67,2.15l.17-.23c-.12,1.27-.23,2.56-.34,3.86l0,.22-.22,0-6.35.86-.22,0-.08-.2c-.23-.6-.45-1.21-.68-1.81l-.34-.91-.17-.46-.08-.23-.05-.11,0-.06v0h0c.45.35.13.09.23.17h0a16.33,16.33,0,0,1-4.11-1.08l.29-.05-3,2.49-.17.14-.18-.13-5.1-3.89-.17-.13.09-.2c.55-1.21,1.1-2.42,1.61-3.52l0,.27a16.23,16.23,0,0,1-2.14-3.67l.22.16-3.85-.34-.21,0,0-.21c-.29-2.2-.58-4.36-.85-6.35l0-.2.19-.07,3.63-1.35-.15.2a15.51,15.51,0,0,1,1.09-4.1l0,.23c-.87-1-1.72-2.05-2.48-3l-.12-.13.11-.14,3.9-5.09.1-.13.14.07,3.52,1.62-.19,0a16.51,16.51,0,0,1,3.66-2.11l-.1.14c.13-1.39.26-2.69.37-3.86v-.11l.11,0,6.36-.81h.07l0,.07q.63,1.74,1,2.7c.1.29.18.53.25.71A2.31,2.31,0,0,1,120.8,194.81Z",
    style: {
      fill: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,237.69a10,10,0,0,1,2.54.67l1.86-1.56,3.21,2.44-1,2.21a10.05,10.05,0,0,1,1.32,2.27l2.43.21.54,4-2.28.86a10,10,0,0,1-.67,2.54l1.56,1.86-2.44,3.21-2.21-1a10.05,10.05,0,0,1-2.27,1.32l-.22,2.42-4,.54-.85-2.27a10,10,0,0,1-2.54-.68l-1.86,1.57-3.21-2.44,1-2.22a9.77,9.77,0,0,1-1.32-2.26l-2.42-.22-.55-4,2.28-.85a9.91,9.91,0,0,1,.67-2.54L97,241.89l2.44-3.2,2.21,1a10.05,10.05,0,0,1,2.27-1.32l.22-2.43,4-.54.85,2.28Zm-1.64,5.54a4.32,4.32,0,1,0,4.86,3.7A4.32,4.32,0,0,0,107.36,243.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.36,243.23l.27-.06a3.36,3.36,0,0,1,.8,0,4.33,4.33,0,0,1,2.65,1.21,4.46,4.46,0,0,1-5.28,7.08,4.35,4.35,0,0,1-1.82-1.86,4.45,4.45,0,0,1,.1-4.27,4.3,4.3,0,0,1,2.23-1.88,4,4,0,0,1,.77-.19l.28,0s-.38.08-1,.34a4.34,4.34,0,0,0-2.07,1.88,4.19,4.19,0,0,0,0,4,4.06,4.06,0,0,0,1.7,1.71,4.13,4.13,0,0,0,4.86-.66,4,4,0,0,0,1.18-2.1,4.2,4.2,0,0,0-1.09-3.84,4.35,4.35,0,0,0-2.49-1.26C107.75,243.2,107.36,243.27,107.36,243.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,237.69l-.06-.13-.18-.43c-.16-.4-.38-1-.66-1.7l.05,0-4,.57.07-.08c-.06.74-.12,1.55-.19,2.43v.06l-.06,0a10,10,0,0,0-2.24,1.32l0,0-.06,0-2.22-1,.15,0L97.13,242v-.17l1.56,1.86.06.06,0,.09a9.55,9.55,0,0,0-.66,2.5v.09l-.08,0-2.28.86.1-.17c.17,1.25.36,2.61.55,4l-.15-.14,2.42.21h.1l0,.09a9.49,9.49,0,0,0,1.31,2.23l.06.08,0,.09-1,2.22,0-.21,3.2,2.44H102c.58-.5,1.22-1,1.86-1.57l.08-.07.1,0a9.5,9.5,0,0,0,2.49.66h0l.14.11h0v.05l0,.08.05.14.11.29.21.57c.14.38.29.76.43,1.13l-.19-.11,4-.54-.15.16c.07-.82.15-1.63.22-2.43v-.1l.09,0a9.17,9.17,0,0,0,2.23-1.3l.08-.06.1,0,2.21,1-.2.06c.83-1.1,1.65-2.16,2.44-3.21v.2l-1.56-1.86-.06-.08,0-.08a9.86,9.86,0,0,0,.67-2.5v-.09l.08,0,2.29-.85-.1.15c-.18-1.4-.36-2.73-.53-4l.12.12-2.42-.22h-.08l0-.07a10,10,0,0,0-1.3-2.25l0-.05,0-.07c.38-.8.71-1.52,1-2.21l0,.13-3.19-2.46h.09l-1.88,1.54,0,0,0,0a10.59,10.59,0,0,0-1.88-.59l-.48-.09-.16,0h.16l.49.07a9,9,0,0,1,1.91.54h-.06l1.85-1.58.05,0,0,0,3.22,2.41.07,0,0,.08c-.31.69-.63,1.41-1,2.22v-.12a10,10,0,0,1,1.35,2.29l-.11-.07,2.43.2h.1l0,.11c.17,1.26.36,2.58.55,4l0,.11-.11,0-2.28.86.1-.12a10.16,10.16,0,0,1-.68,2.58l0-.16,1.56,1.86.09.1-.08.1-2.44,3.21-.08.1-.12,0-2.21-1,.17,0a10.21,10.21,0,0,1-2.31,1.35l.11-.15q-.1,1.2-.21,2.43l0,.14h-.13l-4,.55-.14,0-.05-.13-.42-1.14-.22-.57-.11-.29,0-.14,0-.07v-.06h0l.14.11h0a10.51,10.51,0,0,1-2.58-.68l.17,0-1.86,1.56-.11.09-.11-.08L98.81,256l-.11-.09.06-.12,1-2.22,0,.18a10.1,10.1,0,0,1-1.34-2.31l.13.1-2.42-.22H96l0-.13c-.18-1.38-.36-2.73-.53-4l0-.12.12,0,2.28-.85-.1.12a10,10,0,0,1,.69-2.57l0,.14L96.92,242l-.08-.08.07-.09,2.45-3.2.06-.07.09,0,2.21,1h-.12a10.42,10.42,0,0,1,2.3-1.33l-.06.09.23-2.42v-.08h.07l4-.51h0l0,0,.6,1.7.15.44A.87.87,0,0,1,109,237.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-103"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220.18,
    cy: 66.16,
    r: 21.74,
    transform: "translate(-9.72 65.58) rotate(-16.58)",
    style: {
      fill: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.49,64.73a2.37,2.37,0,0,1,0,.35c0,.26,0,.61,0,1v.76c0,.28,0,.58.08.91a16.86,16.86,0,0,0,.32,2.27A20.55,20.55,0,0,0,201,76,21.74,21.74,0,0,0,206,82.4a21.45,21.45,0,0,0,8.79,4.6,21.67,21.67,0,0,0,11.34-.21,21.22,21.22,0,0,0,2.88-1.05,21.55,21.55,0,0,0,2.74-1.51,27.57,27.57,0,0,0,2.57-1.91A26.43,26.43,0,0,0,236.62,80a20.8,20.8,0,0,0,3.46-5.71A21.3,21.3,0,0,0,241,60.73a21.14,21.14,0,0,0-2.68-6.12A25,25,0,0,0,236.35,52a24.18,24.18,0,0,0-2.3-2.23,23.68,23.68,0,0,0-2.51-1.87,24.24,24.24,0,0,0-2.72-1.41,21.63,21.63,0,0,0-11.22-1.69,21.69,21.69,0,0,0-15.2,9.15,20.5,20.5,0,0,0-2.79,5.57,15.92,15.92,0,0,0-.61,2.2c-.07.32-.15.62-.2.9s-.07.52-.1.75q-.09.64-.15,1a1.68,1.68,0,0,1-.06.35,1.33,1.33,0,0,1,0-.35c0-.26.06-.6.1-1,0-.23.05-.49.07-.76s.12-.58.18-.91a17.05,17.05,0,0,1,.57-2.23,20.5,20.5,0,0,1,2.74-5.68,22,22,0,0,1,15.39-9.4A22,22,0,0,1,229,46.05a22.92,22.92,0,0,1,2.78,1.44,22.22,22.22,0,0,1,2.58,1.9,20,20,0,0,1,4.34,5,21.29,21.29,0,0,1,2.75,6.25,21.74,21.74,0,0,1-.91,13.85A21.6,21.6,0,0,1,237,80.29a26.34,26.34,0,0,1-2.32,2.4,26,26,0,0,1-2.64,2,22.48,22.48,0,0,1-2.8,1.54,21.67,21.67,0,0,1-2.95,1.06,21.86,21.86,0,0,1-25.6-11.16,20.67,20.67,0,0,1-2-6,16.36,16.36,0,0,1-.27-2.29c0-.33,0-.64-.06-.92l0-.76c0-.44,0-.78,0-1A1.6,1.6,0,0,1,198.49,64.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.06,66.82a4.06,4.06,0,0,1-.77.06l-2.11,0c-1.8,0-4.3,0-7.12,0h-.14V65.41c0-3.15,0-6,0-8.06,0-1,0-1.82,0-2.44a6.47,6.47,0,0,1,.05-.9,5.41,5.41,0,0,1,.06.9c0,.62,0,1.44,0,2.44,0,2.06,0,4.91,0,8.06v1.41l-.14-.13c2.82,0,5.32,0,7.12,0l2.11,0A7.06,7.06,0,0,1,230.06,66.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,48a6,6,0,0,1,.14,1.83,6,6,0,0,1-.14,1.83,6,6,0,0,1-.14-1.83A6,6,0,0,1,220.13,48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,50.92a6,6,0,0,1-1.18,1.37,5.6,5.6,0,0,1-1.37,1.17,6,6,0,0,1,1.18-1.37A5.6,5.6,0,0,1,230,50.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.83,57.25a7.57,7.57,0,0,1-1.5,1,7.72,7.72,0,0,1-1.58.87A4.75,4.75,0,0,1,234.19,58,4.65,4.65,0,0,1,235.83,57.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,66.64a22.3,22.3,0,0,1-5,0,22.3,22.3,0,0,1,5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,66.3a9.8,9.8,0,0,1-2.35.14A9.92,9.92,0,0,1,200,66.3a10.59,10.59,0,0,1,2.36-.14A10.46,10.46,0,0,1,204.69,66.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.13,73.3a10.44,10.44,0,0,1-1.78,1.61,10.22,10.22,0,0,1-1.95,1.39,10.44,10.44,0,0,1,1.78-1.61A10.22,10.22,0,0,1,207.13,73.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.16,78.7A16.87,16.87,0,0,1,212,80.8a14.53,14.53,0,0,1-1.29,2,8.29,8.29,0,0,1,1.05-2.2A8.05,8.05,0,0,1,213.16,78.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,85.68a11.1,11.1,0,0,1-.14-2.5,11,11,0,0,1,.14-2.49,11,11,0,0,1,.14,2.49A11.1,11.1,0,0,1,220.13,85.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.87,82.36A7.38,7.38,0,0,1,228.81,81a7.26,7.26,0,0,1-1.67-1.84A22.56,22.56,0,0,1,229,80.74,23,23,0,0,1,230.87,82.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.9,76.93a8.35,8.35,0,0,1-1.64-1.45,8.94,8.94,0,0,1-1.46-1.65,8.74,8.74,0,0,1,1.65,1.45A8.55,8.55,0,0,1,235.9,76.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,59.61a7.1,7.1,0,0,1-1.45-1.26,6.72,6.72,0,0,1-1.26-1.46,6.72,6.72,0,0,1,1.46,1.26A6.5,6.5,0,0,1,206.9,59.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.12,53.06a7,7,0,0,1-1.43-1.23,6.15,6.15,0,0,1-1.23-1.42,6.41,6.41,0,0,1,1.43,1.22A6.15,6.15,0,0,1,213.12,53.06Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPlanPana);
export default __webpack_public_path__ + "static/media/Business Plan-pana.28080d07969ef85d04eb40c9755ebe7f.svg";
export { ForwardRef as ReactComponent };